/* global.js - deobfuscated 2026-05-22 (webcrack). Backdoor removed. */
function getFocusableElements(_0x429143) {
  return Array.from(_0x429143.querySelectorAll("summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"));
}
document.querySelectorAll("[id^=\"Details-\"] summary").forEach(_0x138f41 => {
  _0x138f41.setAttribute("role", "button");
  _0x138f41.setAttribute("aria-expanded", _0x138f41.parentNode.hasAttribute("open"));
  if (_0x138f41.nextElementSibling.getAttribute("id")) {
    _0x138f41.setAttribute("aria-controls", _0x138f41.nextElementSibling.id);
  }
  _0x138f41.addEventListener("click", _0x3adf1e => {
    _0x3adf1e.currentTarget.setAttribute("aria-expanded", !_0x3adf1e.currentTarget.closest("details").hasAttribute("open"));
  });
  if (_0x138f41.closest("header-drawer")) {
    return;
  }
  _0x138f41.parentElement.addEventListener("keyup", onKeyUpEscape);
});
const trapFocusHandlers = {};
function trapFocus(_0x65dfa3, _0x164719 = _0x65dfa3) {
  var _0x21689c = getFocusableElements(_0x65dfa3);
  var _0x16d205 = _0x21689c[0];
  var _0x1aa90c = _0x21689c[_0x21689c.length - 1];
  removeTrapFocus();
  trapFocusHandlers.focusin = _0x9f0c1b => {
    if (_0x9f0c1b.target !== _0x65dfa3 && _0x9f0c1b.target !== _0x1aa90c && _0x9f0c1b.target !== _0x16d205) {
      return;
    }
    document.addEventListener("keydown", trapFocusHandlers.keydown);
  };
  trapFocusHandlers.focusout = function () {
    document.removeEventListener("keydown", trapFocusHandlers.keydown);
  };
  trapFocusHandlers.keydown = function (_0x4c331e) {
    if (_0x4c331e.code.toUpperCase() !== "TAB") {
      return;
    }
    if (_0x4c331e.target === _0x1aa90c && !_0x4c331e.shiftKey) {
      _0x4c331e.preventDefault();
      _0x16d205.focus();
    }
    if ((_0x4c331e.target === _0x65dfa3 || _0x4c331e.target === _0x16d205) && _0x4c331e.shiftKey) {
      _0x4c331e.preventDefault();
      _0x1aa90c.focus();
    }
  };
  document.addEventListener("focusout", trapFocusHandlers.focusout);
  document.addEventListener("focusin", trapFocusHandlers.focusin);
  _0x164719.focus();
  if (_0x164719.tagName === "INPUT" && ["search", "text", "email", "url"].includes(_0x164719.type) && _0x164719.value) {
    _0x164719.setSelectionRange(0, _0x164719.value.length);
  }
}
try {
  document.querySelector(":focus-visible");
} catch (_0x288f1c) {
  focusVisiblePolyfill();
}
function focusVisiblePolyfill() {
  const _0x2c9f08 = ["ARROWUP", "ARROWDOWN", "ARROWLEFT", "ARROWRIGHT", "TAB", "ENTER", "SPACE", "ESCAPE", "HOME", "END", "PAGEUP", "PAGEDOWN"];
  let _0x207574 = null;
  let _0x482f13 = null;
  window.addEventListener("keydown", _0x43dc45 => {
    if (_0x2c9f08.includes(_0x43dc45.code.toUpperCase())) {
      _0x482f13 = false;
    }
  });
  window.addEventListener("mousedown", _0x288b1a => {
    _0x482f13 = true;
  });
  window.addEventListener("focus", () => {
    if (_0x207574) {
      _0x207574.classList.remove("focused");
    }
    if (_0x482f13) {
      return;
    }
    _0x207574 = document.activeElement;
    _0x207574.classList.add("focused");
  }, true);
}
function pauseAllMedia() {
  document.querySelectorAll(".js-youtube").forEach(_0x36af24 => {
    _0x36af24.contentWindow.postMessage("{\"event\":\"command\",\"func\":\"pauseVideo\",\"args\":\"\"}", "*");
  });
  document.querySelectorAll(".js-vimeo").forEach(_0x4dc9eb => {
    _0x4dc9eb.contentWindow.postMessage("{\"method\":\"pause\"}", "*");
  });
  document.querySelectorAll("media-gallery template video").forEach(_0x33121d => _0x33121d.pause());
  document.querySelectorAll("product-model").forEach(_0x5a2334 => {
    if (_0x5a2334.modelViewerUI) {
      _0x5a2334.modelViewerUI.pause();
    }
  });
}
function removeTrapFocus(_0x2a730f = null) {
  document.removeEventListener("focusin", trapFocusHandlers.focusin);
  document.removeEventListener("focusout", trapFocusHandlers.focusout);
  document.removeEventListener("keydown", trapFocusHandlers.keydown);
  if (_0x2a730f) {
    _0x2a730f.focus();
  }
}
function onKeyUpEscape(_0x1d8d91) {
  if (_0x1d8d91.code.toUpperCase() !== "ESCAPE") {
    return;
  }
  const _0x39944a = _0x1d8d91.target.closest("details[open]");
  if (!_0x39944a) {
    return;
  }
  const _0x1086aa = _0x39944a.querySelector("summary");
  _0x39944a.removeAttribute("open");
  _0x1086aa.setAttribute("aria-expanded", false);
  _0x1086aa.focus();
}
class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector("input");
    this.changeEvent = new Event("change", {
      bubbles: true
    });
    this.input.addEventListener("change", this.onInputChange.bind(this));
    this.querySelectorAll("button").forEach(_0x4fa2ed => _0x4fa2ed.addEventListener("click", this.onButtonClick.bind(this)));
  }
  quantityUpdateUnsubscriber = undefined;
  connectedCallback() {
    this.validateQtyRules();
    this.quantityUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.quantityUpdate, this.validateQtyRules.bind(this));
  }
  disconnectedCallback() {
    if (this.quantityUpdateUnsubscriber) {
      this.quantityUpdateUnsubscriber();
    }
  }
  onInputChange(_0x1030e2) {
    this.validateQtyRules();
  }
  onButtonClick(_0x496043) {
    _0x496043.preventDefault();
    const _0x412bbf = this.input.value;
    if (_0x496043.target.name === "plus") {
      this.input.stepUp();
    } else {
      this.input.stepDown();
    }
    if (_0x412bbf !== this.input.value) {
      this.input.dispatchEvent(this.changeEvent);
    }
  }
  validateQtyRules() {
    const _0x3b493f = parseInt(this.input.value);
    if (this.input.min) {
      const _0x35a89e = parseInt(this.input.min);
      const _0x428103 = this.querySelector(".quantity__button[name='minus']");
      _0x428103.classList.toggle("disabled", _0x3b493f <= _0x35a89e);
    }
    if (this.input.max) {
      const _0x2e713d = parseInt(this.input.max);
      const _0x1a0384 = this.querySelector(".quantity__button[name='plus']");
      _0x1a0384.classList.toggle("disabled", _0x3b493f >= _0x2e713d);
    }
  }
}
customElements.define("quantity-input", QuantityInput);
function debounce(_0x13d16c, _0x430e81) {
  let _0x163ea2;
  return (..._0x141654) => {
    clearTimeout(_0x163ea2);
    _0x163ea2 = setTimeout(() => _0x13d16c.apply(this, _0x141654), _0x430e81);
  };
}
function fetchConfig(_0x422038 = "json") {
  return {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Accept: "application/" + _0x422038
    }
  };
}
if (typeof window.Shopify == "undefined") {
  window.Shopify = {};
}
Shopify.bind = function (_0x56dc9b, _0xd201c1) {
  return function () {
    return _0x56dc9b.apply(_0xd201c1, arguments);
  };
};
Shopify.setSelectorByValue = function (_0x26f452, _0x519617) {
  for (var _0x38ef30 = 0, _0x42ddfd = _0x26f452.options.length; _0x38ef30 < _0x42ddfd; _0x38ef30++) {
    var _0x1a120c = _0x26f452.options[_0x38ef30];
    if (_0x519617 == _0x1a120c.value || _0x519617 == _0x1a120c.innerHTML) {
      _0x26f452.selectedIndex = _0x38ef30;
      return _0x38ef30;
    }
  }
};
Shopify.addListener = function (_0x15326d, _0x16b218, _0x430f81) {
  if (_0x15326d.addEventListener) {
    _0x15326d.addEventListener(_0x16b218, _0x430f81, false);
  } else {
    _0x15326d.attachEvent("on" + _0x16b218, _0x430f81);
  }
};
Shopify.postLink = function (_0x184e4e, _0x40572e) {
  _0x40572e = _0x40572e || {};
  var _0x273228 = _0x40572e.method || "post";
  var _0xf3c892 = _0x40572e.parameters || {};
  var _0x219e72 = document.createElement("form");
  _0x219e72.setAttribute("method", _0x273228);
  _0x219e72.setAttribute("action", _0x184e4e);
  for (var _0x4503a6 in _0xf3c892) {
    var _0x34a79e = document.createElement("input");
    _0x34a79e.setAttribute("type", "hidden");
    _0x34a79e.setAttribute("name", _0x4503a6);
    _0x34a79e.setAttribute("value", _0xf3c892[_0x4503a6]);
    _0x219e72.appendChild(_0x34a79e);
  }
  document.body.appendChild(_0x219e72);
  _0x219e72.submit();
  document.body.removeChild(_0x219e72);
};
Shopify.CountryProvinceSelector = function (_0x3d3a02, _0x2f6ec5, _0x385a68) {
  this.countryEl = document.getElementById(_0x3d3a02);
  this.provinceEl = document.getElementById(_0x2f6ec5);
  this.provinceContainer = document.getElementById(_0x385a68.hideElement || _0x2f6ec5);
  Shopify.addListener(this.countryEl, "change", Shopify.bind(this.countryHandler, this));
  this.initCountry();
  this.initProvince();
};
Shopify.CountryProvinceSelector.prototype = {
  initCountry: function () {
    var _0x8e6553 = this.countryEl.getAttribute("data-default");
    Shopify.setSelectorByValue(this.countryEl, _0x8e6553);
    this.countryHandler();
  },
  initProvince: function () {
    var _0x5d5df1 = this.provinceEl.getAttribute("data-default");
    if (_0x5d5df1 && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, _0x5d5df1);
    }
  },
  countryHandler: function (_0x1dd61f) {
    var _0x1e04e1 = this.countryEl.options[this.countryEl.selectedIndex];
    var _0x44ac91 = _0x1e04e1.getAttribute("data-provinces");
    var _0x4b99ed = JSON.parse(_0x44ac91);
    this.clearOptions(this.provinceEl);
    if (_0x4b99ed && _0x4b99ed.length == 0) {
      this.provinceContainer.style.display = "none";
    } else {
      for (var _0x85550d = 0; _0x85550d < _0x4b99ed.length; _0x85550d++) {
        var _0x1e04e1 = document.createElement("option");
        _0x1e04e1.value = _0x4b99ed[_0x85550d][0];
        _0x1e04e1.innerHTML = _0x4b99ed[_0x85550d][1];
        this.provinceEl.appendChild(_0x1e04e1);
      }
      this.provinceContainer.style.display = "";
    }
  },
  clearOptions: function (_0x4fa24f) {
    while (_0x4fa24f.firstChild) {
      _0x4fa24f.removeChild(_0x4fa24f.firstChild);
    }
  },
  setOptions: function (_0x3dc20e, _0x1465a4) {
    for (var _0x113d4f = 0, _0x446047 = _0x1465a4.length; _0x113d4f < _0x1465a4.length; _0x113d4f++) {
      var _0x42f867 = document.createElement("option");
      _0x42f867.value = _0x1465a4[_0x113d4f];
      _0x42f867.innerHTML = _0x1465a4[_0x113d4f];
      _0x3dc20e.appendChild(_0x42f867);
    }
  }
};
class InternalVideo extends HTMLElement {
  constructor() {
    super();
    this.playButton = this.querySelector(".internal-video__play");
    this.noPlayBtn = this.dataset.noPlayBtn === "true";
    this.loaded = false;
    this.video = this.querySelector("video");
    this.invalidFormatSrc = this.video.querySelector("source[type=\"application/x-mpegURL\"]");
    if (this.invalidFormatSrc) {
      this.invalidFormatSrc.remove();
    }
    if (this.playButton) {
      this.playButton.addEventListener("click", this.playVideo.bind(this));
    }
    if (this.video) {
      this.video.addEventListener("ended", this.endedVideo.bind(this));
    }
    this.video.addEventListener("waiting", this.showSpinner.bind(this));
    this.video.addEventListener("canplaythrough", this.hideSpinner.bind(this));
    this.video.addEventListener("play", this.hideSpinner.bind(this));
    if (this.dataset.autoplay === "true" && "IntersectionObserver" in window) {
      const _0x473649 = {
        root: null,
        rootMargin: "0px",
        threshold: 0.05
      };
      this.observer = new IntersectionObserver(this.handleIntersection.bind(this), _0x473649);
      this.observer.observe(this);
    }
  }
  playVideo() {
    if (this.video.paused) {
      if (!this.loaded) {
        this.video.load();
        this.loaded = true;
      }
      this.video.play();
      this.classList.add("internal-video--playing");
      if (this.playButton && this.noPlayBtn) {
        this.playButton.style.visibility = "hidden";
      }
    } else {
      this.video.pause();
      this.classList.remove("internal-video--playing");
    }
  }
  endedVideo() {
    this.classList.remove("internal-video--playing");
  }
  hideSpinner() {
    this.classList.remove("internal-video--loading");
  }
  showSpinner() {
    this.classList.add("internal-video--loading");
  }
  handleIntersection(_0x517536) {
    _0x517536.forEach(_0xaf5168 => {
      if (_0xaf5168.isIntersecting) {
        for (let _0x4d7c56 of this.video.querySelectorAll("source[data-src]")) {
          _0x4d7c56.setAttribute("src", _0x4d7c56.getAttribute("data-src"));
          _0x4d7c56.removeAttribute("data-src");
        }
        this.video.load();
        var _0x2c5fe2 = this.video.play();
        if (_0x2c5fe2 !== undefined) {
          _0x2c5fe2.catch(_0x3f6471 => {
            console.log("catch");
            if (_0x3f6471.name === "NotAllowedError") {
              this.classList.remove("internal-video--playing");
              if (this.playButton && this.noPlayBtn) {
                this.playButton.style.visibility = "visible";
              }
            }
          }).then(() => {
            console.log("then");
            this.video.play();
          });
        }
        this.observer.disconnect();
      }
    });
  }
}
customElements.define("internal-video", InternalVideo);
class MenuDrawer extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector("details");
    this.addEventListener("keyup", this.onKeyUp.bind(this));
    this.addEventListener("focusout", this.onFocusOut.bind(this));
    this.bindEvents();
  }
  bindEvents() {
    this.querySelectorAll("summary").forEach(_0x26f4a5 => _0x26f4a5.addEventListener("click", this.onSummaryClick.bind(this)));
    this.querySelectorAll("button:not(.menu-drawer__close-menu-btn)").forEach(_0x419ad1 => _0x419ad1.addEventListener("click", this.onCloseButtonClick.bind(this)));
  }
  onKeyUp(_0xa88ba3) {
    if (_0xa88ba3.code.toUpperCase() !== "ESCAPE") {
      return;
    }
    const _0x3144e5 = _0xa88ba3.target.closest("details[open]");
    if (!_0x3144e5) {
      return;
    }
    if (_0x3144e5 === this.mainDetailsToggle) {
      this.closeMenuDrawer(_0xa88ba3, this.mainDetailsToggle.querySelector("summary"));
    } else {
      this.closeSubmenu(_0x3144e5);
    }
  }
  onSummaryClick(_0x448867) {
    const _0x3eea47 = _0x448867.currentTarget;
    const _0x52586a = _0x3eea47.parentNode;
    const _0x189ae5 = _0x52586a.closest(".has-submenu");
    const _0x4926ff = _0x52586a.hasAttribute("open");
    const _0x1dbffd = window.matchMedia("(prefers-reduced-motion: reduce)");
    function _0x355cb7() {
      trapFocus(_0x3eea47.nextElementSibling, _0x52586a.querySelector("button"));
      _0x3eea47.nextElementSibling.removeEventListener("transitionend", _0x355cb7);
    }
    if (_0x52586a === this.mainDetailsToggle) {
      if (_0x4926ff) {
        _0x448867.preventDefault();
      }
      if (_0x4926ff) {
        this.closeMenuDrawer(_0x448867, _0x3eea47);
      } else {
        this.openMenuDrawer(_0x3eea47);
      }
      if (window.matchMedia("(max-width: 990px)")) {
        document.documentElement.style.setProperty("--viewport-height", window.innerHeight + "px");
      }
    } else {
      setTimeout(() => {
        _0x52586a.classList.add("menu-opening");
        _0x3eea47.setAttribute("aria-expanded", true);
        if (_0x189ae5) {
          _0x189ae5.classList.add("submenu-open");
        }
        if (!_0x1dbffd || _0x1dbffd.matches) {
          _0x355cb7();
        } else {
          _0x3eea47.nextElementSibling.addEventListener("transitionend", _0x355cb7);
        }
      }, 100);
    }
  }
  openMenuDrawer(_0x5aca50) {
    setTimeout(() => {
      this.mainDetailsToggle.classList.add("menu-opening");
    });
    _0x5aca50.setAttribute("aria-expanded", true);
    trapFocus(this.mainDetailsToggle, _0x5aca50);
    document.body.classList.add("overflow-hidden-" + this.dataset.breakpoint);
  }
  closeMenuDrawer(_0x5f75f7, _0x14b2ab = false) {
    if (_0x5f75f7 === undefined) {
      return;
    }
    this.mainDetailsToggle.classList.remove("menu-opening");
    this.mainDetailsToggle.querySelectorAll("details").forEach(_0x1a1c5c => {
      _0x1a1c5c.removeAttribute("open");
      _0x1a1c5c.classList.remove("menu-opening");
    });
    this.mainDetailsToggle.querySelectorAll(".submenu-open").forEach(_0x6e15c3 => {
      _0x6e15c3.classList.remove("submenu-open");
    });
    document.body.classList.remove("overflow-hidden-" + this.dataset.breakpoint);
    removeTrapFocus(_0x14b2ab);
    this.closeAnimation(this.mainDetailsToggle);
  }
  onFocusOut(_0x31e936) {
    setTimeout(() => {
      if (this.mainDetailsToggle.hasAttribute("open") && !this.mainDetailsToggle.contains(document.activeElement)) {
        this.closeMenuDrawer();
      }
    });
  }
  onCloseButtonClick(_0x4b9dfd) {
    const _0x42b8df = _0x4b9dfd.currentTarget.closest("details");
    this.closeSubmenu(_0x42b8df);
  }
  closeSubmenu(_0x36ceff) {
    const _0x384401 = _0x36ceff.closest(".submenu-open");
    if (_0x384401) {
      _0x384401.classList.remove("submenu-open");
    }
    _0x36ceff.classList.remove("menu-opening");
    _0x36ceff.querySelector("summary").setAttribute("aria-expanded", false);
    removeTrapFocus(_0x36ceff.querySelector("summary"));
    this.closeAnimation(_0x36ceff);
  }
  closeAnimation(_0x33aa9c) {
    let _0x2bf5a5;
    const _0x2a5403 = _0x452416 => {
      if (_0x2bf5a5 === undefined) {
        _0x2bf5a5 = _0x452416;
      }
      const _0x3e3ae8 = _0x452416 - _0x2bf5a5;
      if (_0x3e3ae8 < 400) {
        window.requestAnimationFrame(_0x2a5403);
      } else {
        _0x33aa9c.removeAttribute("open");
        if (_0x33aa9c.closest("details[open]")) {
          trapFocus(_0x33aa9c.closest("details[open]"), _0x33aa9c.querySelector("summary"));
        }
      }
    };
    window.requestAnimationFrame(_0x2a5403);
  }
}
customElements.define("menu-drawer", MenuDrawer);
class HeaderDrawer extends MenuDrawer {
  constructor() {
    super();
    this.querySelectorAll(".menu-drawer__close-menu-btn").forEach(_0x56b534 => _0x56b534.addEventListener("click", this.closeButtonClick.bind(this)));
  }
  openMenuDrawer(_0x1d04f8) {
    this.header = this.header || document.querySelector(".section-header");
    this.borderOffset = this.borderOffset || this.closest(".header-wrapper").classList.contains("header-wrapper--border-bottom") ? 1 : 0;
    document.documentElement.style.setProperty("--header-bottom-position", parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset) + "px");
    this.header.classList.add("menu-open");
    setTimeout(() => {
      this.mainDetailsToggle.classList.add("menu-opening");
    });
    _0x1d04f8.setAttribute("aria-expanded", true);
    trapFocus(this.mainDetailsToggle, _0x1d04f8);
    document.body.classList.add("overflow-hidden-" + this.dataset.breakpoint);
  }
  closeMenuDrawer(_0x55837c, _0x22127a) {
    super.closeMenuDrawer(_0x55837c, _0x22127a);
    this.header.classList.remove("menu-open");
  }
  closeButtonClick(_0x58f9db) {
    this.closeMenuDrawer(_0x58f9db, this.mainDetailsToggle.querySelector("summary"));
    this.querySelector(".header__icon--menu[aria-expanded=true]").setAttribute("aria-expanded", "false");
  }
}
customElements.define("header-drawer", HeaderDrawer);
class ModalDialog extends HTMLElement {
  constructor() {
    super();
    this.querySelector("[id^=\"ModalClose-\"]").addEventListener("click", this.hide.bind(this, false));
    this.addEventListener("keyup", _0x15c19f => {
      if (_0x15c19f.code.toUpperCase() === "ESCAPE") {
        this.hide();
      }
    });
    if (this.classList.contains("media-modal")) {
      this.addEventListener("pointerup", _0x39a860 => {
        if (_0x39a860.pointerType === "mouse" && !_0x39a860.target.closest("deferred-media, product-model")) {
          this.hide();
        }
      });
    } else {
      this.addEventListener("click", _0x3f2c9d => {
        if (_0x3f2c9d.target === this) {
          this.hide();
        }
      });
    }
  }
  connectedCallback() {
    if (this.moved) {
      return;
    }
    this.moved = true;
    document.body.appendChild(this);
  }
  show(_0xd1aa21) {
    this.openedBy = _0xd1aa21;
    const _0x132600 = this.querySelector(".template-popup");
    document.body.classList.add("overflow-hidden");
    this.setAttribute("open", "");
    if (_0x132600) {
      _0x132600.loadContent();
    }
    trapFocus(this, this.querySelector("[role=\"dialog\"]"));
    window.pauseAllMedia();
  }
  hide() {
    document.body.classList.remove("overflow-hidden");
    document.body.dispatchEvent(new CustomEvent("modalClosed"));
    this.removeAttribute("open");
    removeTrapFocus(this.openedBy);
    window.pauseAllMedia();
  }
}
customElements.define("modal-dialog", ModalDialog);
const searchResultsElem = "body";
class ModalOpener extends HTMLElement {
  constructor() {
    super();
    const _0x26c65e = this.querySelector("button:not(.internal-video__play, .internal-video__sound-btn)");
    if (!_0x26c65e) {
      return;
    }
    _0x26c65e.addEventListener("click", () => {
      const _0x28bb9d = document.querySelector(this.getAttribute("data-modal"));
      if (_0x28bb9d) {
        _0x28bb9d.show(_0x26c65e);
      }
    });
  }
}
customElements.define("modal-opener", ModalOpener);
class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    const _0x5480d0 = this.querySelector("[id^=\"Deferred-Poster-\"]");
    if (!_0x5480d0) {
      return;
    }
    _0x5480d0.addEventListener("click", this.loadContent.bind(this));
  }
  loadContent(_0x4f825a = true) {
    window.pauseAllMedia();
    if (!this.getAttribute("loaded")) {
      const _0xead507 = document.createElement("div");
      _0xead507.appendChild(this.querySelector("template").content.firstElementChild.cloneNode(true));
      this.setAttribute("loaded", true);
      const _0x439491 = this.appendChild(_0xead507.querySelector("video, model-viewer, iframe"));
      if (_0x4f825a) {
        _0x439491.focus();
      }
    }
  }
}
customElements.define("deferred-media", DeferredMedia);
const defaultDirection = document.currentScript && document.currentScript.dataset.isRtl === "true" ? "rtl" : "ltr";
const isRtl = defaultDirection === "rtl" ? true : false;
class SliderComponent extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector("[id^=\"Slider-\"]");
    this.sliderItems = this.querySelectorAll("[id^=\"Slide-\"]");
    this.enableSliderLooping = false;
    this.currentPageElement = this.querySelector(".slider-counter--current");
    this.pageTotalElement = this.querySelector(".slider-counter--total");
    this.prevButton = this.querySelector("button[name=\"previous\"]");
    this.nextButton = this.querySelector("button[name=\"next\"]");
    this.scrollMultiplier = isRtl ? -1 : 1;
    if (!this.slider || !this.nextButton) {
      return;
    }
    this.internalVideos = this.querySelectorAll("internal-video");
    this.pauseVideos = this.dataset.pauseVideos === "true" && this.internalVideos.length > 0;
    this.initPages();
    const _0x5a4793 = new ResizeObserver(_0x5a4e6b => this.initPages());
    _0x5a4793.observe(this.slider);
    this.slider.addEventListener("scroll", this.update.bind(this));
    this.prevButton.addEventListener("click", this.onButtonClick.bind(this));
    this.nextButton.addEventListener("click", this.onButtonClick.bind(this));
    this.sliderControlWrapper = this.querySelector(".slider-buttons");
    if (!this.sliderControlWrapper || !this.sliderControlWrapper.querySelector(".slider-counter__link")) {
      return;
    }
    this.sliderFirstItemNode = this.slider.querySelector(".slider__slide");
    this.sliderControlLinksArray = Array.from(this.sliderControlWrapper.querySelectorAll(".slider-counter__link"));
    this.sliderControlLinksArray.forEach(_0x351303 => _0x351303.addEventListener("click", this.linkToSlide.bind(this)));
  }
  initPages() {
    this.sliderItemsToShow = Array.from(this.sliderItems).filter(_0x344295 => _0x344295.clientWidth > 0);
    if (this.sliderItemsToShow.length < 2) {
      return;
    }
    const _0x183ccc = this.sliderItemsToShow[0].offsetLeft * this.scrollMultiplier;
    this.sliderItemOffset = this.sliderItemsToShow[1].offsetLeft * this.scrollMultiplier - _0x183ccc;
    this.slidesPerPage = Math.floor((this.slider.clientWidth - _0x183ccc) / this.sliderItemOffset);
    this.totalPages = this.sliderItemsToShow.length - this.slidesPerPage + 1;
    this.update();
  }
  resetPages() {
    this.sliderItems = this.querySelectorAll("[id^=\"Slide-\"]");
    this.initPages();
  }
  update() {
    if (!this.slider || !this.nextButton) {
      return;
    }
    const _0x228554 = this.currentPage;
    this.currentPage = Math.round(this.slider.scrollLeft * this.scrollMultiplier / this.sliderItemOffset) + 1;
    if (this.currentPageElement && this.pageTotalElement) {
      this.currentPageElement.textContent = this.currentPage;
      this.pageTotalElement.textContent = this.totalPages;
    }
    if (this.currentPage != _0x228554) {
      this.dispatchEvent(new CustomEvent("slideChanged", {
        detail: {
          currentPage: this.currentPage,
          currentElement: this.sliderItemsToShow[this.currentPage - 1]
        }
      }));
    }
    this.sliderControlButtons = this.querySelectorAll(".slider-counter__link");
    if (this.sliderControlButtons.length > 0) {
      this.sliderControlButtons.forEach(_0x3aa34d => {
        _0x3aa34d.classList.remove("slider-counter__link--active");
        _0x3aa34d.removeAttribute("aria-current");
      });
      const _0x1a94b1 = this.sliderControlButtons[this.currentPage - 1];
      if (_0x1a94b1) {
        _0x1a94b1.classList.add("slider-counter__link--active");
        _0x1a94b1.setAttribute("aria-current", true);
      }
    }
    const _0x4ffa8e = this.sliderItems[this.currentPage - 1];
    if (this.pauseVideos && _0x4ffa8e) {
      this.internalVideos.forEach(_0x2a820b => {
        if (_0x4ffa8e.id != _0x2a820b.closest("[id^=\"Slide-\"]").id) {
          if (_0x2a820b.dataset.autoplay !== "true") {
            _0x2a820b.querySelector("video").pause();
            _0x2a820b.classList.remove("internal-video--playing");
          }
        }
      });
    }
    if (this.enableSliderLooping) {
      return;
    }
    if (this.isSlideVisible(this.sliderItemsToShow[0]) && this.slider.scrollLeft === 0) {
      this.prevButton.setAttribute("disabled", "disabled");
    } else {
      this.prevButton.removeAttribute("disabled");
    }
    if (this.isSlideVisible(this.sliderItemsToShow[this.sliderItemsToShow.length - 1], true)) {
      this.nextButton.setAttribute("disabled", "disabled");
    } else {
      this.nextButton.removeAttribute("disabled");
    }
  }
  isSlideVisible(_0x435b9e, _0x4c7333 = false, _0x147f22 = 0, _0x1f6681 = false) {
    const _0x3df27f = _0x4c7333 ? 10 : 0;
    const _0x108756 = _0x435b9e.offsetLeft * this.scrollMultiplier + _0x435b9e.clientWidth;
    const _0x381190 = _0x435b9e.offsetLeft * this.scrollMultiplier;
    const _0x5cd5a8 = this.slider.scrollLeft * this.scrollMultiplier - _0x3df27f + _0x147f22;
    const _0x36f466 = this.slider.scrollLeft * this.scrollMultiplier + this.slider.clientWidth + _0x3df27f - _0x147f22;
    const _0x102d36 = _0x108756 <= _0x36f466;
    const _0x4f7d4a = _0x1f6681 ? _0x381190 >= _0x5cd5a8 : true;
    return _0x102d36 && _0x4f7d4a;
  }
  onButtonClick(_0x42d453) {
    _0x42d453.preventDefault();
    const _0x4d5cf3 = _0x42d453.currentTarget.dataset.step || 1;
    const _0x4c23d9 = this.slider.scrollLeft * this.scrollMultiplier;
    this.slideScrollPosition = _0x42d453.currentTarget.name === "next" ? _0x4c23d9 + _0x4d5cf3 * this.sliderItemOffset : _0x4c23d9 - _0x4d5cf3 * this.sliderItemOffset;
    this.slider.scrollTo({
      left: this.slideScrollPosition * this.scrollMultiplier
    });
  }
  linkToSlide(_0x52ce3d) {
    _0x52ce3d.preventDefault();
    const _0x4b981d = this.sliderControlLinksArray.indexOf(_0x52ce3d.currentTarget);
    const _0x16849b = _0x4b981d + 1 - this.currentPage;
    const _0x2d103c = this.slider.scrollLeft * this.scrollMultiplier;
    const _0x1ed352 = this.sliderFirstItemNode.clientWidth;
    const _0x5d3196 = _0x2d103c + _0x1ed352 * _0x16849b;
    this.slider.scrollTo({
      left: _0x5d3196 * this.scrollMultiplier
    });
  }
}
customElements.define("slider-component", SliderComponent);
window.addEventListener("DOMContentLoaded", function () {
  const _0x521178 = document.querySelectorAll(".comparison-slider");
  _0x521178.forEach(_0x56b3ab => {
    const _0x584fc = _0x56b3ab.querySelector(".comparison-slider__overlay");
    const _0x29e892 = _0x56b3ab.querySelector(".comparison-slider__overlay-under");
    const _0x1dd52b = _0x56b3ab.querySelector(".comparison-slider__line");
    const _0x4a304b = _0x56b3ab.querySelector(".comparison-slider__input");
    _0x4a304b.addEventListener("input", _0x5958fb => {
      const _0x221716 = _0x5958fb.currentTarget.value;
      _0x584fc.style.width = _0x221716 + "%";
      _0x29e892.style.width = 100 - _0x221716 + "%";
      _0x1dd52b.style.left = _0x221716 + "%";
    });
  });
  const _0x53c5cf = document.querySelector(".sign-up-popup-modal");
  if (_0x53c5cf) {
    const _0x270b4b = _0x53c5cf.getAttribute("data-test-mode");
    const _0x746064 = _0x53c5cf.getAttribute("data-delay-seconds");
    const _0x1544ad = _0x53c5cf.getAttribute("data-delay-days");
    const _0x2e4fff = _0x53c5cf.getAttribute("data-display-timer");
    const _0x1099f3 = _0x53c5cf.getAttribute("data-timer-duration");
    const _0x59f0df = document.querySelector(".sign-up-popup-overlay");
    const _0x4aeeb5 = _0x53c5cf.querySelector(".popup-modal__close");
    const _0x29894e = _0x53c5cf.querySelector(".popup-modal__dismiss-btn");
    const _0x2536a5 = new Date();
    const _0xd86a3f = "promo-bar-data-" + window.location.host;
    if (_0x270b4b === "false") {
      if (this.localStorage.getItem(_0xd86a3f) === null) {
        _0x5dae97();
      } else {
        const _0x45f4f8 = JSON.parse(this.localStorage.getItem(_0xd86a3f));
        const _0x468912 = new Date(_0x45f4f8.next_display_date);
        if (_0x2536a5.getTime() > _0x468912.getTime()) {
          _0x5dae97();
        }
      }
    } else {
      _0x297ff2();
    }
    _0x59f0df.addEventListener("click", function () {
      _0x488f7e();
    });
    _0x4aeeb5.addEventListener("click", function () {
      _0x488f7e();
    });
    if (_0x29894e) {
      _0x29894e.addEventListener("click", function () {
        _0x488f7e();
      });
    }
    function _0x380bf2(_0x5839b0, _0x7aa9a) {
      var _0x444206 = new Date(_0x5839b0);
      _0x444206.setDate(_0x444206.getDate() + _0x7aa9a);
      return _0x444206;
    }
    function _0x5dae97() {
      setTimeout(function () {
        _0x53c5cf.classList.add("popup-modal--active");
        _0x59f0df.classList.add("popup-overlay--active");
        _0x297ff2();
        const _0x47f1d5 = _0x380bf2(_0x2536a5, parseInt(_0x1544ad));
        const _0x113654 = {
          next_display_date: _0x47f1d5,
          dismissed: false
        };
        localStorage.setItem(_0xd86a3f, JSON.stringify(_0x113654));
      }, parseInt(_0x746064) * 1000);
    }
    function _0x297ff2() {
      if (_0x2e4fff === "true") {
        const _0x20d934 = _0x53c5cf.querySelector(".popup-modal__timer__minutes");
        const _0x5ba7fb = _0x53c5cf.querySelector(".popup-modal__timer__seconds");
        let _0x307fa9 = parseFloat(_0x1099f3) * 60;
        let _0x9b69a9 = Math.floor(_0x307fa9 / 60);
        if (_0x9b69a9.toString().length === 1) {
          _0x9b69a9 = "0" + _0x9b69a9;
        }
        let _0x27c4ac = _0x307fa9 % 60;
        if (_0x27c4ac.toString().length === 1) {
          _0x27c4ac = "0" + _0x27c4ac;
        }
        _0x20d934.innerText = _0x9b69a9;
        _0x5ba7fb.innerText = _0x27c4ac;
        const _0x568158 = setInterval(() => {
          _0x307fa9 -= 1;
          let _0xc2a560 = Math.floor(_0x307fa9 / 60);
          if (_0xc2a560.toString().length === 1) {
            _0xc2a560 = "0" + _0xc2a560;
          }
          let _0x44873f = _0x307fa9 % 60;
          if (_0x44873f.toString().length === 1) {
            _0x44873f = "0" + _0x44873f;
          }
          _0x20d934.innerText = _0xc2a560;
          _0x5ba7fb.innerText = _0x44873f;
          if (_0x307fa9 <= 0) {
            _0x307fa9 = parseFloat(_0x1099f3) * 60 - 45;
          }
        }, 1000);
      }
    }
    function _0x488f7e() {
      _0x53c5cf.classList.remove("popup-modal--active");
      _0x59f0df.classList.remove("popup-overlay--active");
    }
  }
  const _0x47b6c7 = document.querySelector(".search-modal__form--polyfill");
  const _0x54552 = _0x47b6c7 ? _0x47b6c7.getAttribute("data-search-value") : null;
  setTimeout(function () {}, 0);
});
class SlideshowComponent extends SliderComponent {
  constructor() {
    super();
    this.sliderControlWrapper = this.querySelector(".slider-buttons");
    this.enableSliderLooping = true;
    this.scrollMultiplier = isRtl ? -1 : 1;
    if (!this.sliderControlWrapper) {
      return;
    }
    this.sliderFirstItemNode = this.slider.querySelector(".slideshow__slide");
    if (this.sliderItemsToShow.length > 0) {
      this.currentPage = 1;
    }
    this.sliderControlLinksArray = Array.from(this.sliderControlWrapper.querySelectorAll(".slider-counter__link"));
    this.sliderControlLinksArray.forEach(_0x4fc1de => _0x4fc1de.addEventListener("click", this.linkToSlide.bind(this)));
    this.slider.addEventListener("scroll", this.setSlideVisibility.bind(this));
    this.setSlideVisibility();
    if (this.slider.getAttribute("data-autoplay") === "true") {
      this.setAutoPlay();
    }
  }
  setAutoPlay() {
    this.sliderAutoplayButton = this.querySelector(".slideshow__autoplay");
    this.autoplaySpeed = this.slider.dataset.speed * 1000;
    this.sliderAutoplayButton.addEventListener("click", this.autoPlayToggle.bind(this));
    this.addEventListener("mouseover", this.focusInHandling.bind(this));
    this.addEventListener("mouseleave", this.focusOutHandling.bind(this));
    this.addEventListener("focusin", this.focusInHandling.bind(this));
    this.addEventListener("focusout", this.focusOutHandling.bind(this));
    this.play();
    this.autoplayButtonIsSetToPlay = true;
  }
  onButtonClick(_0xc850d1) {
    super.onButtonClick(_0xc850d1);
    const _0x4d44ef = this.currentPage === 1;
    const _0xfd27ea = this.currentPage === this.sliderItemsToShow.length;
    if (!_0x4d44ef && !_0xfd27ea) {
      return;
    }
    if (_0x4d44ef && _0xc850d1.currentTarget.name === "previous") {
      this.slideScrollPosition = this.slider.scrollLeft * this.scrollMultiplier + this.sliderFirstItemNode.clientWidth * this.sliderItemsToShow.length;
    } else if (_0xfd27ea && _0xc850d1.currentTarget.name === "next") {
      this.slideScrollPosition = 0;
    }
    this.slider.scrollTo({
      left: this.slideScrollPosition * this.scrollMultiplier
    });
  }
  update() {
    super.update();
    this.sliderControlButtons = this.querySelectorAll(".slider-counter__link");
    this.prevButton.removeAttribute("disabled");
    if (!this.sliderControlButtons.length) {
      return;
    }
    this.sliderControlButtons.forEach(_0x551943 => {
      _0x551943.classList.remove("slider-counter__link--active");
      _0x551943.removeAttribute("aria-current");
    });
    this.sliderControlButtons[this.currentPage - 1].classList.add("slider-counter__link--active");
    this.sliderControlButtons[this.currentPage - 1].setAttribute("aria-current", true);
  }
  autoPlayToggle() {
    this.togglePlayButtonState(this.autoplayButtonIsSetToPlay);
    if (this.autoplayButtonIsSetToPlay) {
      this.pause();
    } else {
      this.play();
    }
    this.autoplayButtonIsSetToPlay = !this.autoplayButtonIsSetToPlay;
  }
  focusOutHandling(_0x564c4d) {
    const _0x47ac00 = _0x564c4d.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(_0x564c4d.target);
    if (!this.autoplayButtonIsSetToPlay || _0x47ac00) {
      return;
    }
    this.play();
  }
  focusInHandling(_0x35da7f) {
    const _0x2cae0b = _0x35da7f.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(_0x35da7f.target);
    if (_0x2cae0b && this.autoplayButtonIsSetToPlay) {
      this.play();
    } else if (this.autoplayButtonIsSetToPlay) {
      this.pause();
    }
  }
  play() {
    this.slider.setAttribute("aria-live", "off");
    clearInterval(this.autoplay);
    this.autoplay = setInterval(this.autoRotateSlides.bind(this), this.autoplaySpeed);
  }
  pause() {
    this.slider.setAttribute("aria-live", "polite");
    clearInterval(this.autoplay);
  }
  togglePlayButtonState(_0x5ddbf3) {
    if (_0x5ddbf3) {
      this.sliderAutoplayButton.classList.add("slideshow__autoplay--paused");
      this.sliderAutoplayButton.setAttribute("aria-label", window.accessibilityStrings.playSlideshow);
    } else {
      this.sliderAutoplayButton.classList.remove("slideshow__autoplay--paused");
      this.sliderAutoplayButton.setAttribute("aria-label", window.accessibilityStrings.pauseSlideshow);
    }
  }
  autoRotateSlides() {
    const _0x263aac = this.currentPage === this.sliderItems.length ? 0 : this.slider.scrollLeft * this.scrollMultiplier + this.slider.querySelector(".slideshow__slide").clientWidth;
    this.slider.scrollTo({
      left: _0x263aac * this.scrollMultiplier
    });
  }
  setSlideVisibility() {
    this.sliderItemsToShow.forEach((_0xf855fa, _0xc03b66) => {
      const _0x28c347 = _0xf855fa.querySelectorAll("a");
      if (_0xc03b66 === this.currentPage - 1) {
        if (_0x28c347.length) {
          _0x28c347.forEach(_0x483469 => {
            _0x483469.removeAttribute("tabindex");
          });
        }
        _0xf855fa.setAttribute("aria-hidden", "false");
        _0xf855fa.removeAttribute("tabindex");
      } else {
        if (_0x28c347.length) {
          _0x28c347.forEach(_0x3d5645 => {
            _0x3d5645.setAttribute("tabindex", "-1");
          });
        }
        _0xf855fa.setAttribute("aria-hidden", "true");
        _0xf855fa.setAttribute("tabindex", "-1");
      }
    });
  }
  linkToSlide(_0x2fffd8) {
    _0x2fffd8.preventDefault();
    const _0x291e7f = this.slider.scrollLeft * this.scrollMultiplier;
    const _0x270f92 = _0x291e7f + this.sliderFirstItemNode.clientWidth * (this.sliderControlLinksArray.indexOf(_0x2fffd8.currentTarget) + 1 - this.currentPage);
    this.slider.scrollTo({
      left: _0x270f92 * this.scrollMultiplier
    });
  }
}
customElements.define("slideshow-component", SlideshowComponent);
function updateVariantStatuses(_0x31bae2, _0x4548ad) {
  _0x4548ad.forEach((_0x1ea910, _0x48a3a4) => {
    if (_0x48a3a4 === 0) {
      return;
    }
    const _0x57b15b = [..._0x1ea910.querySelectorAll("option")];
    const _0xf12d81 = _0x4548ad[_0x48a3a4 - 1].querySelector(":checked").value;
    const _0x2d655a = _0x31bae2.filter(_0x4cfb76 => _0x4cfb76.available && _0x4cfb76["option" + _0x48a3a4] === _0xf12d81).map(_0x3caa60 => _0x3caa60["option" + (_0x48a3a4 + 1)]);
    const _0x443f57 = _0x31bae2.filter(_0x4dcdf7 => _0x4dcdf7["option" + _0x48a3a4] === _0xf12d81).map(_0x38b6fb => _0x38b6fb["option" + (_0x48a3a4 + 1)]);
    _0x57b15b.forEach(_0x11dd64 => {
      _0x11dd64.classList.remove("unavailable", "non-existent");
      if (_0x443f57.includes(_0x11dd64.getAttribute("value"))) {
        if (_0x2d655a.includes(_0x11dd64.getAttribute("value"))) {
          _0x11dd64.innerText = _0x11dd64.getAttribute("value");
        } else {
          _0x11dd64.innerText = window.variantStrings.unavailable_with_option.replace("[value]", _0x11dd64.getAttribute("value"));
          _0x11dd64.classList.add("unavailable");
        }
      } else {
        _0x11dd64.innerText = window.variantStrings.unavailable_with_option.replace("[value]", _0x11dd64.getAttribute("value"));
        _0x11dd64.classList.add("non-existent");
      }
    });
  });
}
function formatMoney(_0x2065f8, _0x5e4fc4, _0x3fcd0b = false) {
  if (typeof _0x2065f8 == "string") {
    _0x2065f8 = _0x2065f8.replace(".", "");
  }
  var _0x14e744 = "";
  var _0x3fe0ef = /\{\{\s*(\w+)\s*\}\}/;
  var _0x1eada0 = _0x5e4fc4;
  function _0x1ca0cf(_0x143218, _0x349408) {
    if (typeof _0x143218 == "undefined") {
      return _0x349408;
    } else {
      return _0x143218;
    }
  }
  function _0x323af7(_0x26a4e6, _0x440835, _0x583e3c, _0x2a98cd) {
    _0x440835 = _0x1ca0cf(_0x440835, 2);
    _0x583e3c = _0x1ca0cf(_0x583e3c, ",");
    _0x2a98cd = _0x1ca0cf(_0x2a98cd, ".");
    if (isNaN(_0x26a4e6) || _0x26a4e6 == null) {
      return 0;
    }
    _0x26a4e6 = (_0x26a4e6 / 100).toFixed(_0x440835);
    var _0x56b99f = _0x26a4e6.split(".");
    var _0x137aef = _0x56b99f[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + _0x583e3c);
    var _0x39898b = _0x56b99f[1] ? _0x2a98cd + _0x56b99f[1] : "";
    if (_0x3fcd0b && _0x39898b === _0x2a98cd + "00") {
      _0x39898b = "";
    }
    return _0x137aef + _0x39898b;
  }
  switch (_0x1eada0.match(_0x3fe0ef)[1]) {
    case "amount":
      _0x14e744 = _0x323af7(_0x2065f8, 2);
      break;
    case "amount_no_decimals":
      _0x14e744 = _0x323af7(_0x2065f8, 0);
      break;
    case "amount_with_comma_separator":
      _0x14e744 = _0x323af7(_0x2065f8, 2, ".", ",");
      break;
    case "amount_no_decimals_with_comma_separator":
      _0x14e744 = _0x323af7(_0x2065f8, 0, ".", ",");
      break;
  }
  return _0x1eada0.replace(_0x3fe0ef, _0x14e744);
}
class StickyAtc extends HTMLElement {
  constructor() {
    super();
    this.isAfterScroll = this.dataset.afterScroll === "true";
    this.isScrollBtn = this.dataset.scrollBtn === "true";
    this.mainAtcBtn = document.querySelector("#ProductSubmitButton-" + this.dataset.section);
    this.floatingBtns = document.querySelectorAll(".floating-btn");
    this.footerSpacing();
    if (this.isAfterScroll) {
      this.checkATCScroll();
      document.addEventListener("scroll", this.checkATCScroll.bind(this));
    } else {
      this.floatingBtns.forEach(_0x53b3f4 => {
        _0x53b3f4.style.setProperty("--sticky-atc-offset", this.offsetHeight + "px");
      });
    }
    if (this.isScrollBtn) {
      this.scrollBtn = this.querySelector(".sticky-atc__scroll-btn");
      this.scrollDestination = document.querySelector("" + this.dataset.scrollDestination.replace("id", this.dataset.section));
      if (this.scrollBtn && this.scrollDestination) {
        this.scrollBtn.addEventListener("click", this.handleScrollBtn.bind(this));
      }
    }
  }
  checkATCScroll() {
    const _0x4112b9 = this.mainAtcBtn.getBoundingClientRect().top + window.scrollY;
    const _0x254614 = _0x4112b9 + this.mainAtcBtn.offsetHeight;
    if (window.scrollY > _0x254614) {
      this.style.transform = "none";
      this.scrolledPast = true;
    } else {
      this.style.transform = "";
      this.scrolledPast = false;
    }
    this.floatingBtns.forEach(_0x54861e => {
      if (this.scrolledPast) {
        _0x54861e.style.setProperty("--sticky-atc-offset", this.offsetHeight + "px");
      } else {
        _0x54861e.style.setProperty("--sticky-atc-offset", "0px");
      }
    });
  }
  handleScrollBtn() {
    const _0xa0591c = document.querySelector("sticky-header");
    const _0x4259f4 = _0xa0591c ? _0xa0591c.clientHeight : 0;
    const _0x578e65 = this.scrollDestination.getBoundingClientRect().top + window.scrollY;
    window.scrollTo({
      top: _0x578e65 - _0x4259f4 - 15,
      behavior: "smooth"
    });
  }
  footerSpacing() {
    let _0x5c354e = document.querySelector(".sticky-atc-footer-spacer");
    if (_0x5c354e) {
      return;
    }
    _0x5c354e = document.createElement("div");
    _0x5c354e.className = "sticky-atc-footer-spacer";
    _0x5c354e.style.height = this.clientHeight - 1 + "px";
    _0x5c354e.style.display = "block";
    const _0x4aa478 = document.querySelector(".footer");
    if (_0x4aa478) {
      _0x5c354e.style.background = window.getComputedStyle(_0x4aa478).background;
    }
    document.body.appendChild(_0x5c354e);
  }
}
customElements.define("sticky-atc", StickyAtc);
function updateVariantStatuses(_0x3983c5, _0x5e5bb6) {
  _0x5e5bb6.forEach((_0x507cad, _0x12dbba) => {
    if (_0x12dbba === 0) {
      return;
    }
    const _0x5be5d3 = [..._0x507cad.querySelectorAll("option")];
    const _0x487ba5 = _0x5e5bb6[_0x12dbba - 1].querySelector(":checked").value;
    const _0x1a0d17 = _0x3983c5.filter(_0x598f6f => _0x598f6f.available && _0x598f6f["option" + _0x12dbba] === _0x487ba5).map(_0x3a1b33 => _0x3a1b33["option" + (_0x12dbba + 1)]);
    const _0x58c35c = _0x3983c5.filter(_0x340c3e => _0x340c3e["option" + _0x12dbba] === _0x487ba5).map(_0x44a055 => _0x44a055["option" + (_0x12dbba + 1)]);
    _0x5be5d3.forEach(_0x3a7303 => {
      _0x3a7303.classList.remove("unavailable", "non-existent");
      if (_0x58c35c.includes(_0x3a7303.getAttribute("value"))) {
        if (_0x1a0d17.includes(_0x3a7303.getAttribute("value"))) {
          _0x3a7303.innerText = _0x3a7303.getAttribute("value");
        } else {
          _0x3a7303.innerText = window.variantStrings.unavailable_with_option.replace("[value]", _0x3a7303.getAttribute("value"));
          _0x3a7303.classList.add("unavailable");
        }
      } else {
        _0x3a7303.innerText = window.variantStrings.unavailable_with_option.replace("[value]", _0x3a7303.getAttribute("value"));
        _0x3a7303.classList.add("non-existent");
      }
    });
  });
}
function findAvailableVariant(_0x3eff7d, _0x4bc35c, _0x106849 = true, _0x23fde2 = false, _0x491f19 = false) {
  for (let _0x536927 = _0x4bc35c.length - 1; _0x536927 >= 0; _0x536927--) {
    const _0x1be4c0 = _0x106849 ? _0x3eff7d.querySelector(".product-form__input:nth-child(" + (_0x536927 + 1) + ")") : _0x3eff7d.querySelectorAll(".select")[_0x536927];
    const _0x5ee048 = _0x106849 ? _0x1be4c0.querySelector(".product-form__input__type").dataset.type : "dropdown";
    const _0x3d1102 = _0x5ee048 === "dropdown" ? _0x1be4c0.querySelectorAll("option") : _0x1be4c0.querySelectorAll("input[type=\"radio\"]");
    let _0x3c4c58 = Array.from(_0x3d1102).findIndex(_0x1954e4 => _0x1954e4.value === _0x4bc35c[_0x536927]);
    let _0x3b2aff = false;
    while (_0x3c4c58 < _0x3d1102.length - 1) {
      _0x3c4c58++;
      const _0x1f211a = _0x3d1102[_0x3c4c58];
      if ((!_0x23fde2 || !_0x1f211a.classList.contains("non-existent")) && (!_0x491f19 || !_0x1f211a.classList.contains("unavailable"))) {
        _0x4bc35c[_0x536927] = _0x1f211a.value;
        _0x3b2aff = true;
        break;
      }
    }
    if (!_0x3b2aff) {
      _0x3c4c58 = Array.from(_0x3d1102).findIndex(_0xd74cdf => _0xd74cdf.value === _0x4bc35c[_0x536927]);
      while (_0x3c4c58 > 0) {
        _0x3c4c58--;
        const _0x5d77ee = _0x3d1102[_0x3c4c58];
        if ((!_0x23fde2 || !_0x5d77ee.classList.contains("non-existent")) && (!_0x491f19 || !_0x5d77ee.classList.contains("unavailable"))) {
          _0x4bc35c[_0x536927] = _0x5d77ee.value;
          _0x3b2aff = true;
          break;
        }
      }
    }
    if (_0x3b2aff) {
      if (_0x5ee048 === "dropdown") {
        _0x1be4c0.querySelector(".select__select").value = _0x4bc35c[_0x536927];
      } else {
        _0x1be4c0.querySelector("input[type=\"radio\"][value=\"" + _0x4bc35c[_0x536927] + "\"]").checked = true;
      }
      _0x3eff7d.dispatchEvent(new Event("change"));
      return true;
    }
  }
  return false;
}
class BundleDeals extends HTMLElement {
  constructor() {
    super();
    this.productContainers = this.querySelectorAll(".bundle-deals__product");
    this.mediaItemContainers = this.querySelectorAll(".bundle-deals__media-item-container");
    this.mediaItemImgs = this.querySelectorAll(".bundle-deals__media-item-img");
    this.checkboxes = this.querySelectorAll(".bundle-deals__checkbox");
    this.variantPickers = this.querySelectorAll(".bundle-deals__variant-select");
    this.prices = this.querySelectorAll(".bundle-deals__price");
    this.comparePrices = this.querySelectorAll(".bundle-deals__compare-price");
    this.totalPrice = this.querySelector(".bundle-deals__total-price");
    this.totalComparePrice = this.querySelector(".bundle-deals__total-compare-price");
    this.updatePrices = this.dataset.updatePrices === "true";
    this.percentageLeft = parseFloat(this.dataset.percentageLeft);
    this.fixedDiscount = parseFloat(this.dataset.fixedDiscount);
    this.currencySymbol = this.dataset.currencySymbol;
    this.selectedVariants = {
      id_1: null,
      id_2: null,
      id_3: null,
      id_4: null,
      id_5: null
    };
    this.formVariants = [];
    this.initIds();
    this.checkboxes.forEach(_0x1501fe => {
      _0x1501fe.addEventListener("change", this.handleCheckboxChange.bind(this));
    });
    this.variantPickers.forEach(_0x93f3d1 => {
      _0x93f3d1.addEventListener("change", this.handleSelectChange.bind(this));
    });
  }
  initIds() {
    this.checkboxes.forEach(_0x3c7efe => {
      this.selectedVariants[_0x3c7efe.dataset.idIndex] = {
        id: _0x3c7efe.dataset.id,
        price: _0x3c7efe.dataset.price,
        comparePrice: _0x3c7efe.dataset.comparePrice,
        checked: true
      };
    });
    this.updateFormIds();
  }
  handleCheckboxChange(_0x4fc419) {
    const _0x50650a = _0x4fc419.currentTarget;
    const _0x186c82 = _0x50650a.checked;
    const _0x315ced = parseInt(_0x50650a.dataset.index);
    this.selectedVariants[_0x50650a.dataset.idIndex].checked = _0x186c82;
    const _0x304fa = this.productContainers[_0x315ced];
    const _0x4bbadc = _0x304fa.querySelector(".bundle-deals__variant-select");
    if (_0x186c82) {
      this.mediaItemContainers[_0x315ced].classList.remove("bundle-deals__media-item--disabled");
      _0x304fa.classList.remove("bundle-deals__product--deselected");
      if (_0x4bbadc) {
        _0x4bbadc.removeAttribute("disabled");
      }
    } else {
      this.mediaItemContainers[_0x315ced].classList.add("bundle-deals__media-item--disabled");
      _0x304fa.classList.add("bundle-deals__product--deselected");
      if (_0x4bbadc) {
        _0x4bbadc.setAttribute("disabled", "");
      }
    }
    this.updateFormIds();
    if (this.updatePrices) {
      this.updateTotalPrice();
    }
  }
  handleSelectChange(_0x188c52) {
    const _0x1fb320 = _0x188c52.currentTarget;
    const _0xa68ec8 = parseInt(_0x1fb320.dataset.index);
    let {
      price: _0x71f51d,
      comparePrice: _0xfa37b2,
      image: _0x274be4
    } = _0x188c52.target.options[_0x188c52.target.selectedIndex].dataset;
    _0x71f51d = parseInt(_0x71f51d);
    _0xfa37b2 = parseInt(_0xfa37b2);
    const _0x54fe83 = _0x188c52.target.value;
    this.selectedVariants[_0x1fb320.dataset.idIndex].id = _0x54fe83;
    this.selectedVariants[_0x1fb320.dataset.idIndex].price = _0x71f51d;
    this.selectedVariants[_0x1fb320.dataset.idIndex].comparePrice = _0xfa37b2;
    this.updateFormIds();
    if (this.updatePrices) {
      this.prices[_0xa68ec8].innerHTML = this.currencySymbol + (_0x71f51d / 100).toFixed(2);
      if (_0xfa37b2 > _0x71f51d) {
        this.comparePrices[_0xa68ec8].innerHTML = this.currencySymbol + (_0xfa37b2 / 100).toFixed(2);
      } else {
        this.comparePrices[_0xa68ec8].innerHTML = "";
      }
      this.updateTotalPrice();
    }
    if (_0x274be4 && _0x274be4.length > 0) {
      this.mediaItemImgs[_0xa68ec8].src = _0x274be4;
    }
  }
  updateFormIds() {
    const _0x43468d = [];
    const _0x297c47 = this.selectedVariants;
    for (const _0x2a87f8 in _0x297c47) {
      const _0x39b7a7 = _0x297c47[_0x2a87f8];
      if (_0x39b7a7 != null && _0x39b7a7.checked) {
        const _0x4f3ff1 = _0x43468d.findIndex(_0x2b67ae => _0x2b67ae.id === _0x39b7a7.id);
        if (_0x4f3ff1 < 0) {
          _0x43468d.unshift({
            id: _0x39b7a7.id,
            quantity: 1
          });
        } else {
          _0x43468d[_0x4f3ff1].quantity += 1;
        }
      }
    }
    this.formVariants = _0x43468d;
  }
  updateTotalPrice() {
    const _0x17df1b = [];
    const _0x8a5ec5 = [];
    const _0x4db1de = this.selectedVariants;
    for (const _0x3e40b3 in _0x4db1de) {
      const _0x4324aa = _0x4db1de[_0x3e40b3];
      if (_0x4324aa != null && _0x4324aa.checked) {
        _0x17df1b.push(parseInt(_0x4324aa.price));
        _0x8a5ec5.push(parseInt(_0x4324aa.comparePrice));
      }
    }
    const _0x31b457 = _0x17df1b.reduce((_0x3fe69f, _0x49bfdd) => _0x3fe69f + _0x49bfdd, 0);
    const _0x3e025f = _0x31b457 * this.percentageLeft - this.fixedDiscount;
    const _0x27a798 = _0x8a5ec5.reduce((_0x490276, _0x274526) => _0x490276 + _0x274526, 0);
    this.totalPrice.innerHTML = this.currencySymbol + (_0x3e025f / 100).toFixed(2);
    if (_0x27a798 > _0x3e025f) {
      this.totalComparePrice.innerHTML = this.currencySymbol + (_0x27a798 / 100).toFixed(2);
    } else {
      this.totalComparePrice.innerHTML = "";
    }
  }
}
customElements.define("bundle-deals", BundleDeals);
class QuantityBreaks extends HTMLElement {
  constructor() {
    super();
    this.inputs = this.querySelectorAll("input[name=\"quantity\"]");
    this.labels = this.querySelectorAll(".quantity-break");
    this.jsonData = this.querySelector("[type=\"application/json\"]");
    this.hasVariants = this.jsonData.dataset.hasVariants === "true";
    this.selectedVariants = {
      input_1: [],
      input_2: [],
      input_3: [],
      input_4: []
    };
    this.updateUnavailable = this.dataset.updateUnavailable === "true";
    this.skipNonExistent = this.dataset.skipNonExistent === "true";
    this.skipUnavailable = this.dataset.skipUnavailable === "true";
    this.formVariants = [];
    this.selectedQuantity = 1;
    this.selectedOffer = 1;
    const _0x5b5e45 = this.querySelector("input[checked]");
    if (_0x5b5e45) {
      this.selectedQuantity = parseInt(_0x5b5e45.value);
      this.selectedOffer = parseInt(_0x5b5e45.dataset.input.replace("input_", ""));
    }
    this.variantSelects = this.querySelectorAll(".quantity-break__selector-item");
    this.updatePrices = this.dataset.updatePrices === "true";
    this.updatePdpPrices = this.dataset.updatePdpPrices === "true";
    this.moneyFormat = this.dataset.moneyFormat;
    if (this.updatePdpPrices) {
      this.offerPrices = {
        offer_1: {
          price: 0,
          compare_price: 0
        },
        offer_2: {
          price: 0,
          compare_price: 0
        },
        offer_3: {
          price: 0,
          compare_price: 0
        },
        offer_4: {
          price: 0,
          compare_price: 0
        }
      };
      this.initOfferPrices();
    }
    if (this.hasVariants) {
      this.initVariants();
    }
    this.inputs.forEach(_0x5b9c50 => {
      _0x5b9c50.addEventListener("change", this.handleChange.bind(this));
    });
    this.variantSelects.forEach(_0x4818eb => {
      _0x4818eb.addEventListener("change", this.handleSelectChange.bind(this));
    });
  }
  initOfferPrices() {
    this.pdpPrices = document.querySelectorAll(".price-" + this.dataset.section);
    const _0x50fd24 = parseInt(this.dataset.basePrice);
    this.labels.forEach((_0x5b6e45, _0x40395b) => {
      const _0x259099 = _0x40395b + 1;
      const _0x95b826 = parseInt(_0x5b6e45.dataset.quantity);
      const _0x2ba11f = parseFloat(_0x5b6e45.dataset.percentageLeft);
      const _0x49d657 = parseFloat(_0x5b6e45.dataset.fixedDiscount);
      const _0x2c0afa = _0x50fd24 * _0x95b826 * _0x2ba11f - _0x49d657;
      const _0x28add6 = parseInt(_0x5b6e45.dataset.baseComparePrice);
      const _0x329244 = _0x28add6 * _0x95b826;
      this.offerPrices["offer_" + _0x259099].price = _0x2c0afa;
      this.offerPrices["offer_" + _0x259099].compare_price = _0x329244;
    });
    this.updateDisplayedPdpPrices();
  }
  updateDisplayedPdpPrices() {
    const _0x1a7acc = this.offerPrices["offer_" + this.selectedOffer].price;
    const _0x1e94b6 = formatMoney(_0x1a7acc, this.moneyFormat);
    const _0x3737f9 = this.offerPrices["offer_" + this.selectedOffer].compare_price;
    const _0x33a958 = formatMoney(_0x3737f9, this.moneyFormat);
    const _0x220a19 = _0x3737f9 > _0x1a7acc;
    this.pdpPrices.forEach(_0x4c3068 => {
      _0x4c3068.classList.toggle("price--on-sale", _0x220a19);
      _0x4c3068.querySelector(".price__regular .price-item--regular").innerHTML = _0x1e94b6;
      _0x4c3068.querySelector(".price__sale .price-item--sale").innerHTML = _0x1e94b6;
      if (_0x220a19) {
        const _0x280097 = _0x4c3068.querySelector(".price__sale .price-item--regular");
        if (_0x280097) {
          _0x280097.innerHTML = _0x33a958;
        }
        const _0x458512 = _0x4c3068.querySelector(".badge__percentage-saved");
        if (_0x458512) {
          const _0x5d8822 = Math.round((_0x3737f9 - _0x1a7acc) * 100 / _0x3737f9);
          _0x458512.innerHTML = _0x5d8822;
        }
        const _0x524dd7 = _0x4c3068.querySelector(".badge__money-saved");
        if (_0x524dd7) {
          const _0xda78e8 = _0x3737f9 - _0x1a7acc;
          const _0x4e4f66 = formatMoney(_0xda78e8, this.moneyFormat, true);
          _0x524dd7.innerHTML = _0x4e4f66;
        }
      }
    });
    const _0x4590ce = document.querySelectorAll(".main-atc-price-span-" + this.dataset.section);
    _0x4590ce.forEach(_0x33912b => {
      _0x33912b.innerHTML = _0x1e94b6;
    });
  }
  handleSelectChange(_0x74de88) {
    const _0x24e470 = _0x74de88.currentTarget;
    const _0x2e090c = Array.from(_0x24e470.querySelectorAll("select"), _0xe2981f => _0xe2981f.value);
    if (this.updateUnavailable) {
      const _0x45a1a5 = this.getVariantData().filter(_0x384bf3 => _0x24e470.querySelector(":checked").value === _0x384bf3.option1);
      const _0x3271b4 = [..._0x24e470.querySelectorAll(".select--small")];
      updateVariantStatuses(_0x45a1a5, _0x3271b4);
    }
    const _0x47a7e2 = this.getVariantData().find(_0x458069 => {
      return !_0x458069.options.map((_0x2f09db, _0x44a29a) => {
        return _0x2e090c[_0x44a29a] === _0x2f09db;
      }).includes(false);
    });
    if (!_0x47a7e2) {
      if (this.skipNonExistent) {
        findAvailableVariant(_0x24e470, _0x2e090c, false, true, this.skipUnavailable);
      }
      return;
    }
    if (this.skipUnavailable && !_0x47a7e2.available) {
      if (findAvailableVariant(_0x24e470, _0x2e090c, false, true, true)) {
        return;
      }
    }
    _0x24e470.dataset.selectedId = _0x47a7e2.id;
    const _0x397049 = _0x24e470.dataset.selectIndex;
    const _0x1a6460 = _0x24e470.closest(".quantity-break");
    const _0x3bf3d4 = _0x24e470.closest(".quantity-break").dataset.input;
    this.selectedVariants[_0x3bf3d4][_0x397049] = _0x47a7e2.id;
    this.updateFormVariants(_0x3bf3d4);
    this.updateMedia(_0x47a7e2);
    if (!this.updatePrices) {
      return;
    }
    var _0x12972c = 0;
    var _0x23e3e8 = 0;
    const _0x4b01d0 = parseFloat(_0x1a6460.dataset.quantity);
    const _0x2a4c23 = parseFloat(_0x1a6460.dataset.percentageLeft);
    const _0x26a915 = parseFloat(_0x1a6460.dataset.fixedDiscount);
    var _0x31a462 = true;
    if (_0x1a6460.dataset.compareMode === "price") {
      _0x31a462 = false;
    }
    for (let _0x46ec6d = 0; _0x46ec6d < _0x4b01d0; _0x46ec6d++) {
      const _0x8af152 = parseInt(this.selectedVariants[_0x3bf3d4][_0x46ec6d]);
      const _0x230baf = this.getVariantData().find(_0x2f2edb => parseInt(_0x2f2edb.id) === _0x8af152);
      if (!_0x230baf) {
        return;
      }
      _0x12972c += _0x230baf.price;
      if (_0x230baf.compare_at_price && _0x31a462 && _0x230baf.compare_at_price > _0x230baf.price) {
        _0x23e3e8 += _0x230baf.compare_at_price;
      } else {
        _0x23e3e8 += _0x230baf.price;
      }
    }
    _0x12972c = _0x12972c * _0x2a4c23 - _0x26a915;
    const _0x5219e9 = _0x23e3e8 - _0x12972c;
    const _0x41f878 = Math.round(_0x5219e9 / 100) * 100;
    const _0x49b881 = formatMoney(_0x12972c, this.moneyFormat, true);
    const _0x4917b7 = formatMoney(_0x23e3e8, this.moneyFormat, true);
    const _0x21081c = formatMoney(_0x5219e9, this.moneyFormat, true);
    const _0x1c549d = formatMoney(_0x41f878, this.moneyFormat, true);
    _0x1a6460.querySelectorAll(".variant-price-update").forEach(_0x3d64ff => {
      let _0x48200e = _0x3d64ff.dataset.text;
      _0x48200e = _0x48200e.replace("[price]", _0x49b881);
      _0x48200e = _0x48200e.replace("[compare_price]", _0x4917b7);
      _0x48200e = _0x48200e.replace("[amount_saved]", _0x21081c);
      _0x48200e = _0x48200e.replace("[amount_saved_rounded]", _0x1c549d);
      _0x3d64ff.innerHTML = _0x48200e;
    });
    const _0x5b7b42 = _0x1a6460.querySelector(".quantity-break__compare-price");
    if (_0x5b7b42) {
      if (_0x23e3e8 > _0x12972c) {
        _0x5b7b42.classList.remove("hidden");
      } else {
        _0x5b7b42.classList.add("hidden");
      }
    }
    if (this.updatePdpPrices) {
      this.offerPrices["offer_" + this.selectedQuantity].price = _0x12972c;
      this.offerPrices["offer_" + this.selectedQuantity].compare_price = _0x23e3e8;
      this.updateDisplayedPdpPrices();
    }
  }
  getVariantData() {
    this.variantData = this.variantData || JSON.parse(this.jsonData.textContent);
    return this.variantData;
  }
  initVariants() {
    if (!this.hasVariants) {
      return;
    }
    this.labels.forEach(_0xb3967e => {
      if (_0xb3967e.querySelector(".quantity-break__variants")) {
        let _0x48a614 = [];
        _0xb3967e.querySelectorAll(".quantity-break__selector-item").forEach(_0x215f14 => {
          _0x48a614.push(_0x215f14.dataset.selectedId);
        });
        this.selectedVariants[_0xb3967e.dataset.input] = _0x48a614;
      }
    });
    this.formVariants = [];
  }
  updateFormVariants(_0x7fd896) {
    if (!this.hasVariants) {
      return;
    }
    const _0x8ace1a = this.selectedVariants[_0x7fd896];
    const _0xe70cd2 = [];
    for (let _0x500729 = 0; _0x500729 < _0x8ace1a.length; _0x500729++) {
      const _0x149cb7 = _0x8ace1a[_0x500729];
      const _0x189de4 = _0xe70cd2.findIndex(_0x12afc2 => _0x12afc2.id === _0x149cb7);
      if (_0x189de4 < 0) {
        _0xe70cd2.unshift({
          id: _0x149cb7,
          quantity: 1
        });
      } else {
        _0xe70cd2[_0x189de4].quantity += 1;
      }
    }
    this.formVariants = _0xe70cd2;
  }
  updateMedia(_0x239983) {
    if (!_0x239983) {
      return;
    }
    if (!_0x239983.featured_media) {
      return;
    }
    const _0x35e28e = document.querySelectorAll("[id^=\"MediaGallery-" + this.dataset.section + "\"]");
    _0x35e28e.forEach(_0x230b4c => _0x230b4c.setActiveMedia(this.dataset.section + "-" + _0x239983.featured_media.id, true));
  }
  handleChange(_0x15d4f7) {
    const _0x3fccd4 = parseInt(_0x15d4f7.target.value);
    this.selectedQuantity = _0x3fccd4;
    this.selectedOffer = parseInt(_0x15d4f7.target.dataset.input.replace("input_", ""));
    if (this.hasVariants) {
      this.updateFormVariants(_0x15d4f7.target.dataset.input);
    }
    if (this.quantityGifts) {
      this.quantityGifts.unlockGifts(_0x3fccd4);
    }
    if (this.updatePdpPrices) {
      this.updateDisplayedPdpPrices();
    }
  }
}
customElements.define("quantity-breaks", QuantityBreaks);
class CustomProductField extends HTMLElement {
  constructor() {
    super();
  }
  connectedCallback() {
    this.fieldName = this.dataset.name;
    this.input = this.querySelector("[type=\"text\"], [type=\"number\"], textarea");
    this.inputRadios = this.querySelectorAll("[type=\"radio\"]");
    this.select = this.querySelector(".select__select");
    this.productForm = document.getElementById("product-form-" + this.dataset.section);
    this.prevValue = this.dataset.defaultValue;
    this.isRequired = this.dataset.required === "true";
    this.isText = true;
    this.notMain = this.dataset.notMain === "true";
    if (this.dataset.type === "select" || this.dataset.type === "pills") {
      this.isText = false;
    }
    this.createInputs();
    if (this.isRequired && this.isText) {
      this.isValid = true;
      this.atcButtons = this.notMain ? document.querySelectorAll("#StickyAtcSubmit-" + this.dataset.section + ", #ProductSubmitButton-" + this.dataset.section) : document.querySelectorAll(".main-product-atc");
      this.mainAtcButton = this.productForm.querySelector("#ProductSubmitButton-" + this.dataset.section);
      this.mainAtcBtnLabel = this.mainAtcButton.querySelector(".main-atc__label");
      this.mainAtcBtnError = this.mainAtcButton.querySelector(".main-atc__error");
      this.atcErrorMsg = this.dataset.atcErrorMsg;
      this.mainAtcButton.dataset.requiredFields = parseInt(this.mainAtcButton.dataset.requiredFields) + 1;
      this.mainAtcBtnError.innerHTML = this.atcErrorMsg;
      this.applyStickyAtcError = this.dataset.applyStickyAtcError === "true";
      this.stickyAtcButton = document.querySelector("#sticky-atc-" + this.dataset.section);
      if (this.applyStickyAtcError && this.stickyAtcButton) {
        this.stickyAtcBtnLabel = this.stickyAtcButton.querySelector(".sticky-atc__label");
        this.stickyAtcBtnError = this.stickyAtcButton.querySelector(".sticky-atc__error");
        this.stickyAtcBtnError.innerHTML = this.atcErrorMsg;
      }
      this.validateValue(this.prevValue, null);
    }
    if (this.input) {
      this.input.addEventListener("input", this.handleChange.bind(this));
    }
    this.inputRadios.forEach(_0x36af98 => {
      _0x36af98.addEventListener("input", this.handleChange.bind(this));
    });
    if (this.select) {
      this.select.addEventListener("change", this.handleChange.bind(this));
    }
  }
  handleChange(_0x8b9c03) {
    const _0x55289a = _0x8b9c03.target.value.trim();
    if (_0x8b9c03.target.checkValidity()) {
      this.prevValue = _0x55289a;
    } else {
      _0x8b9c03.target.value = this.prevValue;
      return;
    }
    this.dataset.value = _0x55289a;
    this.productFormInput.value = _0x55289a;
    if (this.isRequired && this.isText) {
      this.validateValue(_0x55289a, _0x8b9c03.target);
    }
  }
  validateValue(_0x280e52, _0x50cf2a) {
    const _0x4b9d94 = _0x280e52.length > 0 ? true : false;
    if (_0x4b9d94 === this.isValid) {
      return;
    }
    this.isValid = _0x4b9d94;
    if (_0x50cf2a) {
      if (this.isValid) {
        _0x50cf2a.classList.remove("input--error");
        this.mainAtcButton.dataset.validFields = parseInt(this.mainAtcButton.dataset.validFields) + 1;
      } else {
        _0x50cf2a.classList.add("input--error");
        this.mainAtcButton.dataset.validFields = parseInt(this.mainAtcButton.dataset.validFields) - 1;
      }
    }
    const _0xbc1e84 = this.mainAtcButton.dataset.validFields === this.mainAtcButton.dataset.requiredFields;
    const _0x32aa9b = this.mainAtcButton.dataset.unavailable === "true";
    this.atcButtons.forEach(_0x554cdd => {
      if (_0xbc1e84 && !_0x32aa9b) {
        _0x554cdd.removeAttribute("disabled");
      } else {
        _0x554cdd.setAttribute("disabled", "");
      }
    });
    if (this.atcErrorMsg.length === 0) {
      return;
    }
    if (_0xbc1e84) {
      this.mainAtcBtnLabel.style.display = "";
      this.mainAtcBtnError.style.display = "none";
      if (this.applyStickyAtcError && this.stickyAtcButton) {
        this.stickyAtcBtnLabel.style.display = "";
        this.stickyAtcBtnError.style.display = "none";
      }
    } else {
      this.mainAtcBtnLabel.style.display = "none";
      this.mainAtcBtnError.style.display = "";
      if (this.applyStickyAtcError && this.stickyAtcButton) {
        this.stickyAtcBtnLabel.style.display = "none";
        this.stickyAtcBtnError.style.display = "";
      }
    }
  }
  createInputs() {
    this.productFormInput = document.createElement("input");
    this.productFormInput.setAttribute("type", "hidden");
    this.productFormInput.setAttribute("name", "properties[" + this.fieldName + "]");
    this.productFormInput.value = this.dataset.defaultValue;
    this.productForm.appendChild(this.productFormInput);
  }
}
customElements.define("custom-product-field", CustomProductField);
class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.secondarySelectSelector = "StickyAtcVariantPicker-";
    this.secondarySelect = document.getElementById("" + this.secondarySelectSelector + this.dataset.section);
    this.isSecondary = false;
    this.QuantityBreaks = document.getElementById("quantity-breaks-" + this.dataset.section);
    this.skipNonExistent = this.dataset.skipNonExistent === "true";
    this.skipUnavailable = this.dataset.skipUnavailable === "true";
    this.addEventListener("change", this.onVariantChange);
  }
  onVariantChange() {
    this.updateOptions();
    this.updateMasterId();
    this.toggleAddButton(true, "", false);
    this.updatePickupAvailability();
    this.removeErrorMessage();
    this.updateVariantStatuses();
    if (!this.currentVariant) {
      this.toggleAddButton(true, "", true);
      if (this.skipNonExistent && findAvailableVariant(this, this.options, true, true, this.skipUnavailable)) {
        return;
      }
      this.setUnavailable();
    } else {
      if (this.skipUnavailable && !this.currentVariant.available) {
        if (findAvailableVariant(this, this.options, true, true, true)) {
          return;
        }
      }
      this.updateMedia();
      this.updateURL();
      this.updateVariantInput();
      this.renderProductInfo();
      this.updateShareUrl();
    }
  }
  updateOptions() {
    const _0x2ac212 = [];
    this.querySelectorAll(".product-form__input").forEach(_0x100dfc => {
      let _0x1ac34d;
      const _0x1728b2 = _0x100dfc.querySelector(".product-form__input__type").dataset.type;
      if (_0x1728b2 == "dropdown" || _0x1728b2 == "dropdwon") {
        _0x1ac34d = _0x100dfc.querySelector("select").value;
      } else {
        _0x1ac34d = _0x100dfc.querySelector("input[type=\"radio\"]:checked").value;
      }
      _0x2ac212.push(_0x1ac34d);
    });
    this.options = _0x2ac212;
  }
  updateMasterId() {
    this.currentVariant = this.getVariantData().find(_0x561bbb => {
      return !_0x561bbb.options.map((_0x26bc54, _0x3c3e5e) => {
        return this.options[_0x3c3e5e] === _0x26bc54;
      }).includes(false);
    });
  }
  updateMedia() {
    if (!this.currentVariant) {
      return;
    }
    if (!this.currentVariant.featured_media) {
      return;
    }
    const _0x275870 = document.querySelectorAll("[id^=\"MediaGallery-" + this.dataset.section + "\"]");
    _0x275870.forEach(_0x25c0f1 => _0x25c0f1.setActiveMedia(this.dataset.section + "-" + this.currentVariant.featured_media.id, true));
    const _0x5ec4ad = document.querySelector("#ProductModal-" + this.dataset.section + " .product-media-modal__content");
    if (!_0x5ec4ad) {
      return;
    }
    const _0x10a9cc = _0x5ec4ad.querySelector("[data-media-id=\"" + this.currentVariant.featured_media.id + "\"]");
    _0x5ec4ad.prepend(_0x10a9cc);
  }
  updateURL() {
    if (!this.currentVariant || this.dataset.updateUrl === "false") {
      return;
    }
    window.history.replaceState({}, "", this.dataset.url + "?variant=" + this.currentVariant.id);
  }
  updateShareUrl() {
    const _0x350ffb = document.getElementById("Share-" + this.dataset.section);
    if (!_0x350ffb || !_0x350ffb.updateUrl) {
      return;
    }
    _0x350ffb.updateUrl("" + window.shopUrl + this.dataset.url + "?variant=" + this.currentVariant.id);
  }
  updateVariantInput() {
    const _0x9b26ab = document.querySelectorAll("#product-form-" + this.dataset.section + ", #product-form-installment-" + this.dataset.section);
    _0x9b26ab.forEach(_0x526cdf => {
      const _0x3fbb3f = _0x526cdf.querySelector("input[name=\"id\"]");
      _0x3fbb3f.value = this.currentVariant.id;
      _0x3fbb3f.dataset.selectedId = this.currentVariant.id;
      _0x3fbb3f.dispatchEvent(new Event("change", {
        bubbles: true
      }));
    });
  }
  updateVariantStatuses() {
    const _0x38ea5d = this.variantData.filter(_0x2dfd08 => this.querySelector(":checked").value === _0x2dfd08.option1);
    let _0x91792e;
    if (this.isSecondary && this.secondarySelect) {
      _0x91792e = [...this.secondarySelect.querySelectorAll(".product-form__input")];
    } else {
      _0x91792e = [...this.querySelectorAll(".product-form__input")];
    }
    _0x91792e.forEach((_0x31779d, _0x34020e) => {
      if (_0x34020e === 0) {
        return;
      }
      const _0x56b9f9 = [..._0x31779d.querySelectorAll("input[type=\"radio\"], .select__select option")];
      const _0xd6b2f7 = _0x91792e[_0x34020e - 1].querySelector(":checked").value;
      const _0x3d57c9 = _0x38ea5d.filter(_0x159c94 => _0x159c94.available && _0x159c94["option" + _0x34020e] === _0xd6b2f7).map(_0xfb7320 => _0xfb7320["option" + (_0x34020e + 1)]);
      const _0x1a0ccf = _0x38ea5d.filter(_0x1c5837 => _0x1c5837["option" + _0x34020e] === _0xd6b2f7).map(_0x4271c9 => _0x4271c9["option" + (_0x34020e + 1)]);
      this.setInputAvailability(_0x56b9f9, _0x3d57c9, _0x1a0ccf);
    });
  }
  setInputAvailability(_0x227025, _0x4dae05, _0x31f811) {
    _0x227025.forEach(_0x3ad077 => {
      _0x3ad077.classList.remove("unavailable", "non-existent", "disabled");
      const _0x4dcab3 = _0x3ad077.getAttribute("value");
      let _0x2dfb50 = null;
      if (_0x3ad077.dataset.swatch === "true") {
        _0x2dfb50 = _0x3ad077.closest(".color-swatch");
      }
      if (_0x2dfb50) {
        _0x2dfb50.classList.remove("unavailable", "non-existent", "disabled");
      }
      if (_0x31f811.includes(_0x4dcab3)) {
        if (_0x4dae05.includes(_0x4dcab3)) {
          if (_0x3ad077.nodeName === "OPTION") {
            _0x3ad077.innerText = _0x4dcab3;
          } else {
            _0x3ad077.classList.remove("disabled");
            if (_0x2dfb50) {
              _0x2dfb50.classList.remove("disabled");
            }
          }
        } else if (_0x3ad077.nodeName === "OPTION") {
          _0x3ad077.innerText = window.variantStrings.unavailable_with_option.replace("[value]", _0x4dcab3);
          _0x3ad077.classList.add("unavailable");
        } else {
          _0x3ad077.classList.add("disabled", "unavailable");
          if (_0x2dfb50) {
            _0x2dfb50.classList.add("disabled", "unavailable");
          }
        }
      } else if (_0x3ad077.nodeName === "OPTION") {
        _0x3ad077.innerText = window.variantStrings.unavailable_with_option.replace("[value]", _0x4dcab3);
        _0x3ad077.classList.add("non-existent");
      } else {
        _0x3ad077.classList.add("disabled", "non-existent");
        if (_0x2dfb50) {
          _0x2dfb50.classList.add("disabled", "non-existent");
        }
      }
    });
  }
  updatePickupAvailability() {
    const _0x15f958 = document.querySelector("pickup-availability");
    if (!_0x15f958) {
      return;
    }
    if (this.currentVariant && this.currentVariant.available) {
      _0x15f958.fetchAvailability(this.currentVariant.id);
    } else {
      _0x15f958.removeAttribute("available");
      _0x15f958.innerHTML = "";
    }
  }
  removeErrorMessage() {
    const _0x32d3cf = this.closest("section");
    if (!_0x32d3cf) {
      return;
    }
    const _0x5df346 = _0x32d3cf.querySelector("product-form");
    if (_0x5df346) {
      _0x5df346.handleErrorMessage();
    }
  }
  renderProductInfo() {
    const _0x488444 = this.currentVariant.id;
    const _0x155421 = this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section;
    fetch(this.dataset.url + "?variant=" + _0x488444 + "&section_id=" + (this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section)).then(_0x20252a => _0x20252a.text()).then(_0x2edad9 => {
      if (this.currentVariant.id !== _0x488444) {
        return;
      }
      const _0x449862 = new DOMParser().parseFromString(_0x2edad9, "text/html");
      const _0x33369e = document.getElementById("price-" + this.dataset.section);
      const _0x2221c0 = _0x449862.getElementById("price-" + (this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section));
      const _0x105830 = document.getElementById("sticky-atc-separate-price-" + this.dataset.section);
      const _0x12e2da = _0x449862.getElementById("sticky-atc-separate-price-" + (this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section));
      const _0x18df6d = document.getElementById("sticky-atc-price-" + this.dataset.section);
      const _0x47c41d = _0x449862.getElementById("sticky-atc-price-" + (this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section));
      const _0x315e03 = document.getElementById("sticky-atc-image-" + this.dataset.section);
      const _0x5b1ef9 = _0x449862.getElementById("sticky-atc-image-" + (this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section));
      const _0x16439c = document.getElementById("main-atc-price-" + this.dataset.section);
      const _0x105614 = _0x449862.getElementById("main-atc-price-" + (this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section));
      const _0x34576c = document.querySelectorAll("[id^=\"custom-label-" + this.dataset.section + "\"]");
      const _0x38adc7 = _0x449862.querySelectorAll("[id^=\"custom-label-" + (this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section) + "\"]");
      const _0x56ade8 = _0x449862.getElementById("Sku-" + (this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section));
      const _0x197a71 = document.getElementById("Sku-" + this.dataset.section);
      const _0x1f125d = _0x449862.getElementById("Inventory-" + (this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section));
      const _0x469c30 = document.getElementById("Inventory-" + this.dataset.section);
      if (_0x2221c0 && _0x33369e) {
        _0x33369e.innerHTML = _0x2221c0.innerHTML;
      }
      if (_0x105830 && _0x12e2da) {
        _0x105830.innerHTML = _0x12e2da.innerHTML;
      }
      if (_0x18df6d && _0x47c41d) {
        _0x18df6d.innerHTML = _0x47c41d.innerHTML;
      }
      if (_0x315e03 && _0x5b1ef9) {
        _0x315e03.src = _0x5b1ef9.src;
      }
      if (_0x105614 && _0x16439c) {
        _0x16439c.innerHTML = _0x105614.innerHTML;
      }
      if (_0x34576c && _0x38adc7) {
        for (var _0x315637 = 0; _0x315637 < _0x34576c.length; _0x315637++) {
          _0x34576c[_0x315637].innerHTML = _0x38adc7[_0x315637].innerHTML;
        }
      }
      if (_0x1f125d && _0x469c30) {
        _0x469c30.innerHTML = _0x1f125d.innerHTML;
      }
      if (_0x56ade8 && _0x197a71) {
        _0x197a71.innerHTML = _0x56ade8.innerHTML;
        _0x197a71.classList.toggle("visibility-hidden", _0x56ade8.classList.contains("visibility-hidden"));
      }
      if (this.QuantityBreaks) {
        const _0x382bde = _0x449862.getElementById("quantity-breaks-" + (this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section));
        const _0xea4e16 = this.QuantityBreaks.querySelectorAll(".variant-money-change");
        const _0x43393d = _0x382bde.querySelectorAll(".variant-money-change");
        for (let _0x45ffb9 = 0; _0x45ffb9 < _0xea4e16.length; _0x45ffb9++) {
          _0xea4e16[_0x45ffb9].innerHTML = _0x43393d[_0x45ffb9].innerHTML;
        }
        if (this.QuantityBreaks.hasVariants) {
          const _0x43d34a = _0x449862.getElementById("quantity-breaks-" + (this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section));
          this.QuantityBreaks.variantSelects.forEach(_0x2591f2 => {
            _0x2591f2.dataset.selectedId = this.currentVariant.id;
          });
          const _0x1c77ab = this.QuantityBreaks.querySelectorAll(".quantity-break__variant-select");
          const _0x4b8587 = _0x43d34a.querySelectorAll(".quantity-break__variant-select");
          for (let _0x1218ba = 0; _0x1218ba < _0x1c77ab.length; _0x1218ba++) {
            _0x1c77ab[_0x1218ba].innerHTML = _0x4b8587[_0x1218ba].innerHTML;
          }
          this.QuantityBreaks.initVariants();
        }
        if (this.QuantityBreaks.dataset.updatePdpPrices === "true") {
          this.QuantityBreaks.dataset.basePrice = _0x382bde.dataset.basePrice;
          this.QuantityBreaks.labels.forEach(_0x56aa8b => {
            _0x56aa8b.dataset.baseComparePrice = _0x382bde.querySelector("label[data-input=\"" + _0x56aa8b.dataset.input + "\"]").dataset.baseComparePrice;
          });
          this.QuantityBreaks.initOfferPrices();
        }
      }
      if (this.secondarySelect) {
        const _0x578900 = _0x449862.getElementById("" + this.secondarySelectSelector + (this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section));
        if (_0x578900) {
          this.secondarySelect.innerHTML = _0x578900.innerHTML;
        }
      }
      const _0xdd1465 = document.getElementById("price-" + this.dataset.section);
      if (_0xdd1465) {
        _0xdd1465.classList.remove("visibility-hidden");
      }
      if (_0x469c30) {
        _0x469c30.classList.toggle("visibility-hidden", _0x1f125d.innerText === "");
      }
      const _0x5a5613 = _0x449862.getElementById("ProductSubmitButton-" + _0x155421);
      this.toggleAddButton(_0x5a5613 ? _0x5a5613.hasAttribute("disabled") : true, window.variantStrings.soldOut);
      publish(PUB_SUB_EVENTS.variantChange, {
        data: {
          sectionId: _0x155421,
          html: _0x449862,
          variant: this.currentVariant
        }
      });
    });
  }
  toggleAddButton(_0x180a7a = true, _0x49db43, _0x583d53 = true) {
    const _0x4e465b = document.getElementById("product-form-" + this.dataset.section);
    if (!_0x4e465b) {
      return;
    }
    const _0x2d2fd6 = _0x4e465b.querySelector("[name=\"add\"]");
    if (!_0x2d2fd6) {
      return;
    }
    var _0x3f591a = _0x4e465b.querySelector(".main-atc__label__text");
    const _0x2085fa = _0x4e465b.querySelector(".main-atc-price");
    const _0x40fe58 = document.getElementById("StickyAtcSubmitButton-" + this.dataset.section);
    if (_0x180a7a) {
      _0x2d2fd6.setAttribute("disabled", "disabled");
      _0x2d2fd6.setAttribute("data-unavailable", "true");
      if (_0x40fe58) {
        _0x40fe58.setAttribute("disabled", "disabled");
      }
      if (_0x49db43) {
        _0x3f591a.textContent = _0x49db43;
        if (_0x40fe58) {
          _0x40fe58.querySelector(".sticky-atc__label__text").textContent = _0x49db43;
        }
      }
      if (_0x2085fa) {
        _0x2085fa.classList.add("hidden");
      }
    } else {
      _0x2d2fd6.setAttribute("data-unavailable", "false");
      const _0x355af0 = _0x2d2fd6.dataset.customLabel ?? window.variantStrings.addToCart;
      if (_0x3f591a) {
        _0x3f591a.textContent = _0x355af0;
      }
      if (_0x40fe58) {
        _0x40fe58.querySelector(".sticky-atc__label__text").textContent = _0x40fe58.dataset.label;
      }
      if (_0x2d2fd6.dataset.requiredFields === _0x2d2fd6.dataset.validFields) {
        _0x2d2fd6.removeAttribute("disabled");
        _0x2d2fd6.removeAttribute("disabled");
        if (_0x40fe58) {
          _0x40fe58.removeAttribute("disabled");
        }
      }
    }
    if (!_0x583d53) {
      return;
    }
  }
  setUnavailable() {
    const _0x186fbd = document.getElementById("product-form-" + this.dataset.section);
    if (!_0x186fbd) {
      return;
    }
    const _0x48b206 = _0x186fbd.querySelector("[name=\"add\"]");
    var _0x1bcede = _0x186fbd.querySelector(".main-atc__label__text");
    if (!_0x1bcede) {
      _0x1bcede = _0x186fbd.querySelector(".main-atc__label");
    }
    const _0xf40c65 = document.getElementById("price-" + this.dataset.section);
    const _0x67e4fd = document.getElementById("Inventory-" + this.dataset.section);
    const _0x4a2e11 = document.getElementById("Sku-" + this.dataset.section);
    if (!_0x48b206) {
      return;
    }
    _0x1bcede.textContent = window.variantStrings.unavailable;
    if (_0xf40c65) {
      _0xf40c65.classList.add("visibility-hidden");
    }
    if (_0x67e4fd) {
      _0x67e4fd.classList.add("visibility-hidden");
    }
    if (_0x4a2e11) {
      _0x4a2e11.classList.add("visibility-hidden");
    }
  }
  getVariantData() {
    this.variantData = this.variantData || JSON.parse(this.querySelector("[type=\"application/json\"]").textContent);
    return this.variantData;
  }
}
customElements.define("variant-selects", VariantSelects);
class SecondaryVariantSelect extends VariantSelects {
  constructor() {
    super();
    this.secondarySelectSelector = "variant-selects-";
    this.secondarySelect = document.getElementById("" + this.secondarySelectSelector + this.dataset.section);
    this.isSecondary = true;
  }
  updateOptions() {
    this.options = this.querySelector("select").value.split(",");
  }
}
customElements.define("secondary-variant-select", SecondaryVariantSelect);
class SecondaryVariantSelectSeparate extends VariantSelects {
  constructor() {
    super();
    this.secondarySelectSelector = "variant-selects-";
    this.secondarySelect = document.getElementById("" + this.secondarySelectSelector + this.dataset.section);
    this.isSecondary = true;
  }
}
customElements.define("secondary-variant-select-separate", SecondaryVariantSelectSeparate);
class ProductRecommendations extends HTMLElement {
  constructor() {
    super();
  }
  connectedCallback() {
    const _0x16cd0b = (_0x34b8d4, _0x252579) => {
      if (!_0x34b8d4[0].isIntersecting) {
        return;
      }
      _0x252579.unobserve(this);
      fetch(this.dataset.url).then(_0x1e3e1b => _0x1e3e1b.text()).then(_0x5b276c => {
        const _0x56314f = document.createElement("div");
        _0x56314f.innerHTML = _0x5b276c;
        const _0x94693 = _0x56314f.querySelector("product-recommendations");
        if (_0x94693 && _0x94693.innerHTML.trim().length) {
          this.innerHTML = _0x94693.innerHTML;
        }
        if (!this.querySelector("slideshow-component") && this.classList.contains("complementary-products")) {
          this.remove();
        }
        if (_0x56314f.querySelector(".grid__item")) {
          this.classList.add("product-recommendations--loaded");
        }
      }).catch(_0x5df095 => {
        console.error(_0x5df095);
      });
    };
    new IntersectionObserver(_0x16cd0b.bind(this), {
      rootMargin: "0px 0px 400px 0px"
    }).observe(this);
  }
}
customElements.define("product-recommendations", ProductRecommendations);
const currentDate = new Date();
function addDays(_0x46e718, _0x2429dc) {
  var _0x2e8c3d = new Date(_0x46e718);
  _0x2e8c3d.setDate(_0x2e8c3d.getDate() + _0x2429dc);
  return _0x2e8c3d;
}
class DynamicDates extends HTMLElement {
  constructor() {
    super();
    this.dateFormat = this.dataset.dateFormat;
    this.days = this.rearrangeDays(this.dataset.dayLabels.split(","));
    this.months = this.dataset.monthLabels.split(",");
    this.elementsToChange = this.querySelectorAll("[data-dynamic-date=\"true\"]");
    this.daysToSkip = this.parseDaysToSkip(this.dataset.daysToSkip || "");
    this.datesToSkip = this.parseDatesToSkip(this.dataset.datesToSkip || "");
    this.insertDates();
    document.addEventListener("shopify:section:load", _0xc8ee43 => {
      this.insertDates();
    });
  }
  addDaysSkipping(_0x1a2aa2, _0x5d0822) {
    let _0x2c98b4 = new Date(_0x1a2aa2);
    let _0x21eac8 = Number(_0x5d0822) || 0;
    while (_0x21eac8 > 0) {
      _0x2c98b4 = addDays(_0x2c98b4, 1);
      if (!this.isSkipped(_0x2c98b4)) {
        _0x21eac8--;
      }
    }
    return _0x2c98b4;
  }
  parseDaysToSkip(_0x46c0c9) {
    const _0x1a4c55 = new Map([["sunday", 0], ["monday", 1], ["tuesday", 2], ["wednesday", 3], ["thursday", 4], ["friday", 5], ["saturday", 6]]);
    const _0x2a7abd = new Set();
    if (!_0x46c0c9) {
      return _0x2a7abd;
    }
    _0x46c0c9.split(",").forEach(_0x33f6e9 => {
      const _0x5ae5e5 = _0x33f6e9.trim();
      if (_0x1a4c55.has(_0x5ae5e5)) {
        _0x2a7abd.add(_0x1a4c55.get(_0x5ae5e5));
      }
    });
    return _0x2a7abd;
  }
  parseDatesToSkip(_0x347da6) {
    const _0x3363be = new Set();
    if (!_0x347da6) {
      return _0x3363be;
    }
    _0x347da6.split(",").forEach(_0x35a27e => {
      const _0x26c6f1 = _0x35a27e.trim();
      if (!_0x26c6f1) {
        return;
      }
      const _0x347caf = _0x26c6f1.split("-");
      if (_0x347caf.length === 2) {
        const _0x44516d = String(Math.max(1, Math.min(12, Number(_0x347caf[0])))).padStart(2, "0");
        const _0x249cb2 = String(Math.max(1, Math.min(31, Number(_0x347caf[1])))).padStart(2, "0");
        _0x3363be.add(_0x44516d + "-" + _0x249cb2);
      } else if (_0x347caf.length === 3) {
        const _0x3182df = String(Math.max(1, Math.min(12, Number(_0x347caf[1])))).padStart(2, "0");
        const _0x1cf645 = String(Math.max(1, Math.min(31, Number(_0x347caf[2])))).padStart(2, "0");
        _0x3363be.add(_0x3182df + "-" + _0x1cf645);
      }
    });
    return _0x3363be;
  }
  isSkipped(_0x3fe5e4) {
    const _0x225b45 = this.daysToSkip.has(_0x3fe5e4.getDay());
    const _0x17cc28 = String(_0x3fe5e4.getMonth() + 1).padStart(2, "0");
    const _0x59a20e = String(_0x3fe5e4.getDate()).padStart(2, "0");
    const _0x4d0401 = this.datesToSkip.has(_0x17cc28 + "-" + _0x59a20e);
    return _0x225b45 || _0x4d0401;
  }
  nextValidDate(_0x7cfba8) {
    let _0x13745c = new Date(_0x7cfba8);
    while (this.isSkipped(_0x13745c)) {
      _0x13745c = addDays(_0x13745c, 1);
    }
    return _0x13745c;
  }
  insertDates() {
    this.elementsToChange.forEach(_0x3db316 => {
      const _0x2ce428 = _0x3db316.dataset.text;
      const _0x158fdb = parseInt(_0x3db316.dataset.minDays);
      const _0x33714e = parseInt(_0x3db316.dataset.maxDays);
      const _0x414e2c = this.addDaysSkipping(currentDate, _0x158fdb);
      const _0x3bd958 = this.addDaysSkipping(currentDate, _0x33714e);
      let _0x262d3e = "th";
      const _0x48d12d = _0x414e2c.getDate();
      if ([1, 21, 31].includes(_0x48d12d)) {
        _0x262d3e = "st";
      } else if ([2, 22].includes(_0x48d12d)) {
        _0x262d3e = "nd";
      } else if ([3, 23].includes(_0x48d12d)) {
        _0x262d3e = "rd";
      }
      let _0x38d1e5 = "th";
      const _0x527547 = _0x3bd958.getDate();
      if ([1, 21, 31].includes(_0x527547)) {
        _0x38d1e5 = "st";
      } else if ([2, 22].includes(_0x527547)) {
        _0x38d1e5 = "nd";
      } else if ([3, 23].includes(_0x527547)) {
        _0x38d1e5 = "rd";
      }
      let _0x2d6a38;
      let _0xc89686;
      if (this.dateFormat === "day_dd_mm") {
        _0x2d6a38 = this.days[_0x414e2c.getDay()] + ", " + _0x414e2c.getDate() + ". " + this.months[_0x414e2c.getMonth()];
        _0xc89686 = this.days[_0x3bd958.getDay()] + ", " + _0x3bd958.getDate() + ". " + this.months[_0x3bd958.getMonth()];
      } else if (this.dateFormat === "mm_dd") {
        _0x2d6a38 = this.months[_0x414e2c.getMonth()] + " " + _0x414e2c.getDate() + _0x262d3e;
        _0xc89686 = this.months[_0x3bd958.getMonth()] + " " + _0x3bd958.getDate() + _0x38d1e5;
      } else if (this.dateFormat === "dd_mm") {
        _0x2d6a38 = _0x414e2c.getDate() + ". " + this.months[_0x414e2c.getMonth()];
        _0xc89686 = _0x3bd958.getDate() + ". " + this.months[_0x3bd958.getMonth()];
      } else if (this.dateFormat === "dd_mm_no_dot") {
        _0x2d6a38 = _0x414e2c.getDate() + " " + this.months[_0x414e2c.getMonth()];
        _0xc89686 = _0x3bd958.getDate() + " " + this.months[_0x3bd958.getMonth()];
      } else if (this.dateFormat === "day_dd_mm_numeric") {
        const _0x17b663 = String(_0x414e2c.getDate()).padStart(2, "0");
        const _0x4379a4 = String(_0x414e2c.getMonth() + 1).padStart(2, "0");
        _0x2d6a38 = this.days[_0x414e2c.getDay()] + ", " + _0x17b663 + ". " + _0x4379a4 + ".";
        const _0x40ebd9 = String(_0x3bd958.getDate()).padStart(2, "0");
        const _0x47fbce = String(_0x3bd958.getMonth() + 1).padStart(2, "0");
        _0xc89686 = this.days[_0x3bd958.getDay()] + ", " + _0x40ebd9 + ". " + _0x47fbce + ".";
      } else if (this.dateFormat === "dd_mm_numeric") {
        const _0x22704d = String(_0x414e2c.getDate()).padStart(2, "0");
        const _0x468990 = String(_0x414e2c.getMonth() + 1).padStart(2, "0");
        _0x2d6a38 = _0x22704d + ". " + _0x468990 + ".";
        const _0x6b5b73 = String(_0x3bd958.getDate()).padStart(2, "0");
        const _0x3c4f6c = String(_0x3bd958.getMonth() + 1).padStart(2, "0");
        _0xc89686 = _0x6b5b73 + ". " + _0x3c4f6c + ".";
      } else {
        _0x2d6a38 = this.days[_0x414e2c.getDay()] + ", " + this.months[_0x414e2c.getMonth()] + " " + _0x414e2c.getDate() + _0x262d3e;
        _0xc89686 = this.days[_0x3bd958.getDay()] + ", " + this.months[_0x3bd958.getMonth()] + " " + _0x3bd958.getDate() + _0x38d1e5;
      }
      const _0x2bfe31 = _0x2ce428.replace("[start_date]", _0x2d6a38);
      const _0x173680 = _0x2bfe31.replace("[end_date]", _0xc89686);
      _0x3db316.innerHTML = _0x173680;
    });
  }
  rearrangeDays(_0x3540ad) {
    _0x3540ad.unshift(_0x3540ad[6]);
    _0x3540ad.length = 7;
    return _0x3540ad;
  }
}
customElements.define("dynamic-dates", DynamicDates);